module.exports    = {
	"language": "语言",
	"hello": "世界 {{.a}}",
	"c001": "네트워크 오류, 잠시 후 다시 시도해 주세요!",
	"c002": "종료",
	"c003": "로그인",
	"c004": "사용자 이름을 입력해 주세요",
	"c005": "로그인 비밀번호를 입력해 주세요",
	"c006": "저장",
	"c007": "입력하신 계정 또는 비밀번호가 올바르지 않습니다",
	"c008": "계정",
	"c009": "언어",
	"c010": "총",
	"c011": "개",
	"c012": "안녕하세요,",
	"c013": "귀하의 계정이 활성화되지 않았습니다. 관리자에게 문의하십시오",
	"c014": "귀하의 계정이 정지되었습니다. 관리자에게 문의하십시오",
	"c015": "초기화",
	"c016": "웹소켓 연결 실패",
	"c017": "내부 오류",
	"c018": "이 작업을 수행할 권한이 없습니다",
	"c019": "현재 사용자는 이 페이지를 볼 권한이 없습니다",
	"c020": "로그인 정보가 만료되었습니다. 다시 로그인하세요!",
	"c021": "사용자 로그인",
	"c022": "문서",
	"c023": "합격",
	"c024": "불합격",
	"c025": "결과",
	"c026": "시스템",
	"c027": "데이터베이스 연결 오류, 확인해 주세요.",
	"c028": "데이터베이스 초기화 오류, 확인해 주세요.",
	"m001": "오프라인",
	"m002": "온라인",
	"m003": "이상",
	"m004": "삭제됨",
	"m005": "장비 추가",
	"m006": "장비 편집",
	"m007": "장비 관리",
	"m008": "번호",
	"m009": "상태",
	"m010": "장비 번호",
	"m011": "장비명",
	"m012": "소속 지역",
	"m013": "정렬",
	"m014": "IP 주소",
	"m015": "통신 주소",
	"m016": "비고",
	"m017": "업데이트 시간",
	"m018": "작업",
	"m019": "편집",
	"m020": "장비 편집 성공",
	"m021": "장비 추가 성공",
	"m022": "중복된 장비명 또는 장비 번호 또는 IP 주소",
	"m023": "장비명은 비워둘 수 없으며, 길이가 2자 이상이어야 합니다",
	"m024": "장비 번호는 비워둘 수 없으며, 길이가 2자 이상이어야 합니다",
	"m025": "IP 주소는 비워둘 수 없습니다",
	"m026": "포트는 정수여야 하며, 5자리 숫자를 초과할 수 없습니다",
	"m027": "삭제",
	"m028": "복원",
	"m029": "포트",
	"m030": "자동 연결 시작",
	"m031": "참고: 통신 주소는 용접기 프로그래머와 일치해야 합니다",
	"m032": "모든 영역",
	"m033": "모든 상태",
	"m034": "선택하세요",
	"m035": "온라인",
	"m036": "오프라인",
	"m037": "기기 삭제 오류, 잠시 후 다시 시도해 주세요",
	"m038": "기기 복원 오류, 잠시 후 다시 시도해 주세요",
	"m039": "기기 삭제 성공",
	"m040": "기기 복원 성공",
	"m041": "기기 데이터 조회 오류, 잠시 후 다시 시도해 주세요",
	"m042": "IP 형식이 잘못되었습니다",
	"m043": "통신 주소는 정수여야 하며, 5자리 숫자를 초과할 수 없습니다",
	"m044": "소속 지역을 선택해 주세요",
	"m045": "기기 편집 실패",
	"m046": "기기 추가 실패",
	"m047": "기기 이름이 중복됩니다. 수정해 주세요",
	"m048": "기기 번호가 중복됩니다. 수정해 주세요",
	"m049": "IP 주소 중복, 수정해 주세요",
	"m050": "전류 곡선 수집",
	"m051": "전압 곡선 수집",
	"m052": "저항 곡선 수집",
	"m053": "압력 곡선 수집",
	"m054": "자동 연결",
	"m055": "해석 파일 불러오기 오류",
	"m056": "업로드 파일 읽기 오류",
	"m057": "파일 확장자 오류 (.xlsx;.xlsm;.xltx)",
	"m058": "파일 크기 초과 (10M)",
	"m059": "장비",
	"m060": "필드",
	"m061": "가져오기 완료, 총 {{.a}}개 가져옴, 그중 새로 추가된 항목 {{.b}}개",
	"m062": "가져오기 실패",
	"m063": "닫기",
	"m064": "동일 규격, 비교 불가",
	"m065": "컨트롤러 목록 조회 오류",
	"m066": "파일 확장자 허용되지 않음",
	"m067": "비밀번호가 잘못되었습니다. 다시 입력하세요",
	"m068": "업그레이드 성공",
	"m069": "컨트롤러를 공장 초기화할까요?",
	"m070": "장치 유형은 803만 지원합니다",
	"m071": "시스템이 처리 중입니다. 잠시만 기다려 주세요",
	"m072": "작업 추가 성공, 작업 처리 중",
	"m073": "가져오기가 기존 데이터를 덮어씁니다. 정말 가져오시겠습니까?",
	"m074": "파일 쓰기 예외",
	"m075": "장치 이름/장치 번호/IP 주소/비고 조회",
	"m076": "모두 온라인",
	"m077": "모두 오프라인",
	"m078": "모두 온라인 성공",
	"m079": "모두 오프라인 성공",
	"m080": "모두 온라인 실패",
	"m081": "모두 오프라인 실패",
	"m082": "Excel 테이블 생성 실패",
	"m083": "용접 곡선 역직렬화 오류",
	"m084": "경보 기록 획득 오류",
	"m085": "시스템 파라미터 1 쓰기 오류",
	"m086": "시스템 파라미터 2 쓰기 오류",
	"m087": "시스템 파라미터 3 쓰기 오류",
	"m088": "해당 영역을 먼저 추가해야 합니다",
	"m089": "장비 총 수",
	"m090": "재연결",
	"m091": "백업",
	"m092": "규격 매개변수",
	"m093": "시스템 매개변수",
	"m094": "장치를 선택하지 않았습니다!",
	"m095": "백업 매개변수를 선택하지 않았습니다!",
	"m096": "일괄 백업이 진행 중입니다. 잠시만 기다려 주세요",
	"m097": "백업 파일이 존재하지 않습니다!",
	"m098": "백업 파일 압축 오류!",
	"m099": "일괄 백업이 완료되었습니다. 다운로드하세요",
	"m100": "tar 파일 생성 실패",
	"m101": "경로 획득 실패",
	"m102": "백업 성공",
	"m103": "업그레이드할 파일을 선택하세요",
	"m104": "장치 업그레이드",
	"m105": "업그레이드 중 예외 발생",
	"m106": "펌웨어 데이터가 비어 있어 업그레이드할 수 없습니다",
	"m107": "장치「{{.a}}」연결 불가, 확인 후 재시도. 문제 지속 시 장치 재시작",
	"m108": "파일 업그레이드 패키지 아님, 확인 필요",
	"m109": "시작 패킷 전송 실패",
	"m110": "시작 패킷 응답 수신 예외",
	"m111": "데이터 패킷 전송 중 예외, 패킷 위치：",
	"m112": "데이터 패킷 수신 중 오류 발생, 패킷 위치：",
	"m113": "종료 패킷 전송 중 오류 발생",
	"m114": "종료 패킷 수신 중 오류 발생",
	"m115": "장치 업그레이드 중입니다. 잠시만 기다려 주세요",
	"m116": "장치 업그레이드 중",
	"m117": "장치 업그레이드 성공",
	"m118": "장치 업그레이드 실패",
	"m119": "재시도",
	"m120": "시작 대기 중",
	"m121": "업그레이드 진행 상황 개요",
	"m122": "성공：",
	"m123": "실패",
	"m124": "진행 중",
	"m125": "기기 업그레이드 상세 정보",
	"m126": "페이지 새로고침으로 인해 펌웨어 파일이 손실되어 재시도할 수 없습니다.",
	"m127": "기타",
	"m128": "업그레이드 취소됨",
	"m129": "취소 중...",
	"m130": "업그레이드를 취소하면 이후 장치의 업그레이드가 중단됩니다. 정말 취소하시겠습니까?",
	"m131": "온라인 장치",
	"m132": "오프라인 장치",
	"m133": "장치 재연결",
	"m134": "장치명/장치 번호/IP",
	"m135": "관련 장치를 찾을 수 없습니다",
	"m136": "현재 조작 가능한 장치가 없습니다",
	"m137": "장치 ID",
	"m138": "기존 컨트롤러 소프트웨어 버전",
	"m139": "다운로드 실패, 관련 데이터를 찾을 수 없습니다",
	"m140": "작업 결과",
	"m141": "장비 유형",
	"m142": "장비 유형을 선택하십시오",
	"m143": "사용 중인 소프트웨어 버전은 이 장비 유형을 활성화하지 않았습니다. 활성화가 필요하면 제조사에 문의하십시오.",
	"m144": "HRC-803 중주파 용접기",
	"m145": "HRC-802",
	"m146": "HRC-A50",
	"m147": "HRC-501",
	"m148": "HRC-650 용접 품질 모니터",
	"m149": "HRC-670 리벳 품질 모니터",
	"m150": "HRC-62 교류 용접기",
	"m151": "현재 활성화 코드",
	"m152": "매개변수 백업",
	"m153": "매개변수 복원",
	"m154": "장비 가져오기",
	"m155": "모든 장비 내보내기",
	"m156": "장비 매개변수 백업 중입니다. 잠시만 기다려 주세요",
	"m157": "매개변수 백업이 취소되었습니다",
	"m158": "백업 디렉터리를 생성할 수 없습니다. 매개변수 백업 실패",
	"m159": "백업 중 예외 발생, 매개변수 백업 실패",
	"m160": "규격 데이터를 읽을 수 없습니다. 매개변수 백업 실패",
	"m161": "Excel 테이블 생성 실패, 매개변수 백업 실패",
	"m162": "시스템 매개변수 읽기 실패, 매개변수 백업 실패",
	"m163": "장치 오프라인 상태, 매개변수 백업 실패",
	"m164": "매개변수 백업 진행 상황 개요",
	"m165": "매개변수 백업 상세 정보",
	"m166": "장치 매개변수 백업 중",
	"m167": "매개변수 백업 성공",
	"m168": "매개변수 백업 실패",
	"m169": "백업 규격 매개변수",
	"m170": "규격 매개변수 백업 진행률",
	"m171": "시스템 매개변수 백업 진행률",
	"m172": "납땜점 정보 백업 진행률",
	"m173": "업그레이드 작업 재시도 시작됨",
	"m174": "백업 작업 재시도 시작됨",
	"m175": "업그레이드 작업 취소 시작됨",
	"m176": "백업 작업 취소 시작됨",
	"m177": "백업을 취소하면 이후 장치의 백업이 중단됩니다. 정말 취소하시겠습니까?",
	"m178": "tar 압축 파일 선택",
	"m179": "파일 압축 해제 오류, 확인해 주세요",
	"m180": "매개변수 복원 완료",
	"m181": "매개변수 복원 과정에서 예외 발생",
	"m182": "매개변수 복원 진행 상황 개요",
	"m183": "매개변수 복원 상세 정보",
	"m184": "장비 매개변수 복원 중",
	"m185": "매개변수 복원 성공",
	"m186": "매개변수 복원 실패",
	"m187": "규격 매개변수 복원 진행률",
	"m188": "시스템 매개변수 복원 진행률",
	"m189": "납땜점 정보 복원 진행률",
	"m190": "납땜점 정보 가져오기 오류",
	"m191": "백업 취소됨",
	"m192": "매개변수 복원 취소됨",
	"m193": "장치에 백업 또는 복원 작업이 진행 중이어서 다운로드할 수 없습니다",
	"m194": "매개변수 복원을 취소하면 이후 복원 작업이 중단됩니다. 정말 취소하시겠습니까?",
	"m195": "압축 파일에서 해당 장치를 찾을 수 없습니다. 파일을 확인해 주세요",
	"m196": "매개변수 복원 작업 재시도 시작됨",
	"m197": "장치에 다른 작업이 실행 중이어서 조작할 수 없습니다",
	"m198": "복원 가능한 매개변수: ",
	"m199": "활성화 정보에 활성화된 기기 유형이 없으므로, 일시적으로 기기를 추가하거나 수정할 수 없습니다",
	"m200": "해당 기기는 현재 이 작업을 지원하지 않습니다.",
	"m201": "백업 파일",
	"m202": "가져오기 파일의 장치 번호 또는 유형이 일치하지 않습니다. 파일 이름 접두사 형식은 반드시 다음과 같아야 합니다: 장치 번호+{{.a}}",
	"m203": "로그인 비밀번호",
	"m204": "파일을 선택하세요",
	"m205": "데이터 정리 후 복구할 수 없습니다. 정리를 확인하시겠습니까?",
	"m206": "백업 정리",
	"m207": "정리",
	"m208": "정리 성공",
	"m209": "정리 실패",
	"m210": "기기 MAC 주소 충돌",
	"m211": "사용자「{{.a}}」가 기기「{{.b}}」의 매개변수를 백업했습니다:",
	"m212": "현재 장치 열림, 중복 작업 불가",
	"m213": "MAC 주소",
	"m214": "비산 발생 지점",
	"m215": "도움말",
	"p001": "새 영역 만들기",
	"p002": "영역 편집",
	"p003": "영역이 참조되어 삭제할 수 없습니다",
	"p004": "영역 관리",
	"p005": "영역 이름",
	"p006": "영역 메모",
	"p007": "영역 편집 성공",
	"p008": "영역 추가 성공",
	"p009": "중복된 영역 이름",
	"p010": "영역 이름은 비워둘 수 없으며, 길이는 2자 이상이어야 합니다",
	"p011": "정렬 값은 양의 정수여야 하며, 5자리 숫자를 초과할 수 없습니다",
	"p012": "페이지 매개변수 오류",
	"p013": "지역 데이터 조회 오류, 잠시 후 다시 시도해 주세요",
	"p014": "입력 매개변수 ID 오류, 반드시 정수여야 합니다",
	"p015": "데이터 제출 오류",
	"p016": "지역 이름 중복, 수정 후 다시 제출해 주세요",
	"p017": "지역 추가 오류, 잠시 후 다시 시도해 주세요",
	"p018": "지역 업데이트 오류, 잠시 후 다시 시도해 주세요",
	"p019": "구역 점유 여부 확인 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"p020": "구역 삭제 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"p021": "구역 복원 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"p022": "구역 삭제 성공",
	"p023": "구역 복원 성공",
	"p024": "건/페이지",
	"p025": "연마 전 규격 번호",
	"p026": "연마 후 규격 번호",
	"p027": "데이터 없음",
	"p028": "참조 곡선 저장",
	"p029": "해당 기록에 저항 곡선 데이터 없음",
	"p030": "최근 3일간의 연마 전후 저항 곡선",
	"p031": "연마 전후 곡선 데이터 길이 불일치로 선택 불가",
	"p032": "해당 기록에 저항 곡선이 없습니다",
	"p033": "선택한 곡선 길이와 현재 차트 길이가 일치하지 않아 선택할 수 없습니다",
	"p034": "연마 전",
	"p035": "연마 후",
	"p036": "먼저 곡선 기록을 선택하세요",
	"p037": "선택한 기록에 저항 곡선 데이터가 없습니다",
	"p038": "[참조 곡선] 연마 전",
	"p039": "[참조 곡선] 연마 후",
	"p040": "먼저 참조 곡선을 생성하십시오",
	"p041": "참조 곡선 저장 성공",
	"p042": "곡선 참조 기록 조회 오류",
	"p043": "곡선 데이터 오류",
	"p044": "곡선이 저장된 참조 곡선의 변동 범위를 초과하여 생성할 수 없습니다",
	"p045": "실시간 곡선과 참조 곡선의 길이가 일치하지 않습니다",
	"p046": "실시간 연마 후 곡선이 허용 오차 범위를 초과함",
	"p047": "연마 설정",
	"p048": "연마 설정 보기",
	"p049": "연마 설정 관리",
	"p050": "연마 모니터링",
	"p051": "연마 모니터링 보기",
	"p052": "연마 모니터링 관리",
	"p053": "기준 곡선 변동 범위 저장",
	"p054": "기준 곡선 변동 범위 모니터링",
	"p055": "경보 유형",
	"p056": "보기",
	"p057": "[실시간 곡선] 연마 전",
	"p058": "[실시간 곡선] 연마 후",
	"p059": "현재 기준 저항 곡선",
	"p060": "참조 저항 곡선",
	"p061": "저항 곡선 미리보기",
	"p062": "연마 후 저항값이 연마 전 저항값보다 큼",
	"p063": "자동 제거 상하 허용오차 반드시 0보다 큼",
	"p064": "자동 제거 상하 허용오차",
	"p065": "용접 저항 곡선 모니터링 설정",
	"p066": "사전 필터링 활성화",
	"p067": "연마 전-연마 후 평균 저항이 다음보다 클 경우",
	"p068": "정상 분류",
	"p069": "시스템이 허용 오차 범위를 벗어난 곡선을 자동으로 제거했습니다",
	"p070": "연마 후 곡선 상한 허용 오차",
	"p071": "연마 후 곡선 하한 허용 오차",
	"p072": "연마 전후 규격 번호를 입력하십시오",
	"p073": "연마 전-연마 후 저항은 반드시 0보다 커야 함",
	"p074": "연마 후 곡선 상하 허용 오차는 반드시 0보다 커야 함",
	"p075": "사전 필터링이 정상 범위를 초과함",
	"p076": "소프트웨어 버전",
	"p077": "해당 버전은 이 기능을 지원하지 않음",
	"p078": "현재 전류 교정은 시스템 기본값으로 설정되어 있으며 교정이 불가능합니다.",
	"u001": "사용자 관리",
	"u002": "새 사용자 생성",
	"u003": "이름",
	"u004": "역할",
	"u005": "비밀번호",
	"u006": "사용자 편집",
	"u007": "검토자",
	"u008": "운영자",
	"u009": "관리자",
	"u010": "활성화되지 않음",
	"u011": "정상",
	"u012": "동결",
	"u013": "계정 이름은 최소 3자 이상이어야 합니다",
	"u014": "이름은 최소 3자 이상이어야 합니다",
	"u015": "비밀번호는 최소 3자 이상이어야 합니다",
	"u016": "역할을 선택하세요",
	"u017": "상태를 선택하세요",
	"u018": "사용자 편집 성공",
	"u019": "사용자 추가 성공",
	"u020": "사용자 데이터 조회 오류, 잠시 후 다시 시도해 주세요",
	"u021": "사용자 삭제 성공",
	"u022": "사용자 복원 성공",
	"u023": "계정명이 중복됩니다. 수정해 주세요",
	"u024": "사용자 추가 오류, 잠시 후 다시 시도해 주세요",
	"u025": "사용자 편집 오류, 잠시 후 다시 시도해 주세요",
	"u026": "사용자 삭제 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"u027": "사용자 복원 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"u028": "운영자 ID",
	"u029": "역할 관리",
	"u030": "새 역할 생성",
	"u031": "역할 데이터 조회 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"u032": "역할 이름이 중복됩니다. 수정해 주세요",
	"u033": "역할 추가 오류, 잠시 후 다시 시도해 주세요",
	"u034": "역할 편집 오류, 잠시 후 다시 시도해 주세요",
	"u035": "역할 삭제 오류, 잠시 후 다시 시도해 주세요",
	"u036": "역할 복원 오류, 잠시 후 다시 시도해 주세요",
	"u037": "역할 추가 성공",
	"u038": "역할 편집 성공",
	"u039": "캐릭터 삭제 성공",
	"u040": "캐릭터 복원 성공",
	"u041": "캐릭터명",
	"u042": "캐릭터 편집",
	"u043": "캐릭터명은 비워둘 수 없으며, 길이는 2자 이상이어야 합니다",
	"u044": "권한",
	"u045": "지역",
	"u046": "지역 보기",
	"u047": "권한 설정",
	"u048": "장비",
	"u049": "장비 보기",
	"u050": "장비 연결/연결 해제",
	"u051": "사용자",
	"u052": "사용자 보기",
	"u053": "규격 라이브러리 보기",
	"u054": "규격 라이브러리 관리",
	"u055": "시스템 기록 보기",
	"u056": "시스템 기록 관리",
	"u057": "시스템 초기화 보기",
	"u058": "시스템 초기화 관리",
	"u059": "실시간 모니터링 보기",
	"u060": "실시간 모니터링 조작",
	"u061": "실시간 모니터링 보기",
	"u062": "실시간 모니터링 조작",
	"u063": "규격 매개변수 보기",
	"u064": "규격 매개변수 조작",
	"u065": "생산 관리 보기",
	"u066": "생산 관리 작업",
	"u067": "시스템 매개변수 보기",
	"u068": "시스템 매개변수 작업",
	"u069": "용접 기록 보기",
	"u070": "용접 기록 작업",
	"u071": "경보 기록 보기",
	"u072": "경보 기록 작업",
	"u073": "수정 기록 조회",
	"u074": "수정 기록 작업",
	"u075": "용접점 관리 조회",
	"u076": "용접점 관리 작업",
	"u077": "역할 조회",
	"u078": "권한 설정 성공",
	"u079": "비밀번호 확인",
	"u080": "비밀번호 두 번 입력 내용이 일치하지 않습니다. 다시 입력해 주세요!",
	"u081": "등록 정보에 대한 접근 권한이 없습니다. 먼저 권한을 부여해 주세요.",
	"u082": "등록 정보가 누락되었습니다. 먼저 활성화해 주세요.",
	"u083": "등록 정보에 문제가 있습니다. 다시 등록해 주세요.",
	"u084": "현재 버전은 체험판입니다. 이 소프트웨어를 사용하려면 활성화 코드를 신청해 주세요.",
	"u085": "활성화",
	"u086": "제품 활성화",
	"u087": "제품 시리얼 번호",
	"u088": "아래의 제품 시리얼 번호 또는 왼쪽의 QR 코드를 제조사에 보내 활성화 코드를 받으십시오.",
	"u089": "활성화 코드 입력",
	"u090": "문제가 있을 경우 기술 지원팀에 문의하십시오.",
	"u091": "복사 성공.",
	"u092": "복사 실패.",
	"u093": "제품 활성화",
	"u094": "활성화 확인",
	"u095": "활성화 작업",
	"u096": "활성화 장치 유형 오류",
	"u097": "활성화 코드 생성 실패",
	"u098": "활성화 코드가 잘못되었습니다",
	"u099": "활성화 코드를 입력해 주세요",
	"u100": "제품 시리얼 번호가 누락되었습니다",
	"u102": "활성화 코드가 유효하지 않습니다!",
	"u103": "활성화 정보 쓰기 실패, 잠시 후 다시 시도해 주세요",
	"u104": "활성화 성공, 귀하의 활성화 코드 정보를 바탕으로 관련 권한을 개방하겠습니다. 문의 사항이 있으시면 제조사에 연락해 주세요.",
	"u105": "비밀번호 수정",
	"u106": "기존 비밀번호",
	"u107": "새 비밀번호",
	"u108": "기존 비밀번호를 입력하세요",
	"u109": "기존 비밀번호가 맞지 않습니다",
	"u110": "새 비밀번호를 입력하세요",
	"u111": "비밀번호 변경 성공",
	"u112": "비밀번호 변경 실패",
	"u113": "열 표시",
	"u114": "표시할 열 선택",
	"u115": "최소 한 개의 열을 선택하세요",
	"l001": "콘솔",
	"l002": "연결",
	"l003": "모두 연결",
	"l004": "모두 연결 해제",
	"l005": "경고",
	"l006": "연결 해제 성공",
	"l007": "연결 성공",
	"l008": "연결 해제 실패",
	"l009": "연결 실패",
	"l010": "모두 접기",
	"l011": "모두 펼치기",
	"b001": "데이터베이스 관리",
	"b002": "규격 라이브러리",
	"b003": "시스템 매개변수 복사",
	"b004": "매개변수 비교",
	"b005": "전류 제한 매개변수",
	"b006": "규격 번호",
	"b007": "규격 명칭",
	"b008": "용접1 최소",
	"b009": "용접1 최대",
	"b010": "용접2 최소",
	"b011": "용접2 최대",
	"b012": "용접3 최소",
	"b013": "용접3 최대",
	"b014": "전력 모드",
	"b015": "혼합",
	"b016": "정전류",
	"b017": "점유율",
	"b018": "예압",
	"b019": "추압",
	"b020": "예접합",
	"b021": "냉각",
	"b022": "서서히 상승",
	"b023": "용접1",
	"b024": "냉각1",
	"b025": "용접2",
	"b026": "냉각2",
	"b027": "용접3",
	"b028": "서서히 하강",
	"b029": "냉각",
	"b030": "후속 용접",
	"b031": "유지",
	"b032": "정지",
	"b033": "복사",
	"b034": "본 그룹 초기화",
	"b035": "본 그룹 규격 다운로드",
	"b036": "일괄 규격 다운로드",
	"b037": "용접 2펄스 횟수",
	"b038": "구성 데이터 없음",
	"b039": "최대 규격값 획득 오류",
	"b040": "규격",
	"b041": "규격 추가 오류, 잠시 후 다시 시도해 주세요",
	"b042": "규격 추가 성공",
	"b043": "규격 수정 오류, 잠시 후 다시 시도해 주세요",
	"b044": "규격 수정 성공",
	"b045": "규격 삭제 오류, 잠시 후 다시 시도해 주세요",
	"b046": "규격 삭제 성공",
	"b047": "규격 번호 중복, 수정 후 다시 제출해 주세요",
	"b048": "규격 번호 조회 오류, 잠시 후 다시 시도해 주세요",
	"b049": "규격 이름은 비워 둘 수 없습니다",
	"b050": "규격 복사 오류, 잠시 후 다시 시도해 주세요",
	"b051": "규격 복사 성공",
	"b052": "삭제할 규격을 선택하세요",
	"b053": "초기화할 규격을 선택하세요",
	"b054": "복사할 규격을 선택하세요",
	"b055": "삭제된 데이터는 복구할 수 없습니다. 정말 삭제하시겠습니까?",
	"b056": "모두 선택",
	"b057": "소스 장치",
	"b058": "대상 장치",
	"b059": "전체 시스템 파라미터 다운로드",
	"b060": "비교",
	"b061": "비교 방식",
	"b062": "컨트롤러",
	"b063": "규격 라이브러리 데이터 조회 오류",
	"b064": "작업 오류",
	"b065": "파라미터",
	"b066": "용접 1 최소 전류",
	"b067": "용접1 최대 전류",
	"b068": "용접2 최소 전류",
	"b069": "용접2 최대 전류",
	"b070": "용접3 최소 전류",
	"b071": "용접3 최대 전류",
	"b072": "예압 시간",
	"b073": "예압 압력",
	"b074": "추압 시간",
	"b075": "추압 압력",
	"b076": "예접합 제어 선택",
	"b077": "예접합 전류",
	"b078": "예접합 시간",
	"b079": "[보존]예접합 압력 [KN(0-10000) 또는 %(0-100)]",
	"b080": "냉각 시간 0",
	"b081": "[보존]냉각 압력 0 (KN 또는 %)",
	"b082": "서서히 상승 시간",
	"b083": "용접 1 제어 선택",
	"b084": "용접 1 전류",
	"b085": "용접 1 시간",
	"b086": "UIP 기능 선택 0~1",
	"b087": "냉각 시간 1",
	"b088": "[보류] 용접 1 압력 [KN(0-10000) 또는 %(0-100)]",
	"b089": "용접 2 제어 선택",
	"b090": "용접 2 전류",
	"b091": "용접 2 시간",
	"b092": "용접 2 압력",
	"b093": "냉각 시간 2",
	"b094": "UIP 기준값 %",
	"b095": "용접 2 펄스 수",
	"b096": "용접 3 제어 선택",
	"b097": "용접 3 전류",
	"b098": "용접 3 시간",
	"b099": "UIP 상한 허용 오차 %",
	"b100": "서서히 하강 시간",
	"b101": "냉각 시간 3",
	"b102": "UIP 상한 조건 허용 오차 범위",
	"b103": "후속 용접 제어 선택",
	"b104": "후속 용접 전류",
	"b105": "후속 용접 시간",
	"b106": "UIP 하한 조건 허용 오차 범위",
	"b107": "유지 시간",
	"b108": "UIP 하한 허용 오차 범위",
	"b109": "정지 시간",
	"b110": "정지 압력",
	"b111": "전력 제어 선택 (0-2) 0: 정전류 1: 듀티 사이클 2: 혼합",
	"b112": "스플래시 인식 저항 임계값",
	"b113": "컨트롤러 1",
	"b114": "컨트롤러 2",
	"b115": "규격 라이브러리 1",
	"b116": "규격 라이브러리 2",
	"b117": "이 그룹 규격 다운로드",
	"b118": "일괄 규격 다운로드",
	"b119": "장비 번호 선택：",
	"b120": "하위 장치에 다운로드：",
	"b121": "그룹",
	"b122": "하위 장치",
	"b123": "부터",
	"b124": "까지",
	"b125": "다운로드 성공",
	"b126": "장비 유형 획득 오류",
	"b127": "대상 장비 규격 번호 범위 초과(0-{{.a}})",
	"b128": "「{{.a}}」 규격 번호 존재하지 않음",
	"b129": "다운로드 실패",
	"b130": "범위 선택 오류",
	"b131": "다운로드 구간 불일치({{.a}}~{{.b}})",
	"b132": "사용자「{{.a}}」가 장치ID「{{.b}}」에 규격 번호「{{.c}}」를 다운로드했습니다",
	"b133": "사용자「{{.a}}」가 기기ID「{{.b}}」에 대해 규격 번호를 일괄 다운로드했습니다. 「{{.c}}」부터「{{.d}}」까지 다운로드되어「{{.e}}」부터「{{.f}}」까지",
	"b134": "소스 기기와 대상 기기를 선택하세요",
	"b135": "작업 확인",
	"b136": "기기【",
	"b137": "기기【",
	"b138": "】의 시스템 매개변수를 대상 기기로 동기화하시겠습니까?",
	"b139": "제출된 데이터가 유효한 컨트롤러 번호가 아닙니다",
	"b140": "사용자「{{.a}}」가 기계 ID:「{{.b}}」에서「{{.c}}」로 시스템 매개변수 사양을 복사 중",
	"b141": "사양 번호 일치하지 않음, 비교 불가",
	"b142": "사양 번호 범위 초과(0-959)",
	"b143": "사양 번호 범위 초과(0-63)",
	"b144": "컨트롤러를 찾을 수 없습니다",
	"b145": "[보류] 용접 1 압력 [KN(0-10000) 또는 %(0-100)]",
	"b146": "[보류] 냉각 압력 2 [KN(0-10000) 또는 %(0-100)]",
	"b147": "[보류]냉각 압력 3 [KN(0-10000) 또는 %(0-100)]",
	"b148": "[보류]후속 용접 압력 [KN(0-10000) 또는 %(0-100)]",
	"b149": "[보류] 유지 압력 [KN(0-10000) 또는 %(0-100)]",
	"b150": "동일 사양, 비교 불가",
	"b151": "{{.a}} 입력 오류",
	"b152": "입력 검증 오류",
	"b153": "장치에서 오프라인 라이브러리로 동기화",
	"b154": "오프라인 라이브러리에서 장치로 동기화",
	"b155": "번째",
	"b156": "동기화",
	"b157": "범위 선택 오류",
	"b158": "사용자「{{.a}}」가 장치 ID「{{.b}}」를 장치「{{.c}}」에서 오프라인 라이브러리 사양「{{.d}}」로 동기화 중",
	"b159": "동기화 성공",
	"b160": "동기화 실패",
	"b161": "사용자「{{.a}}」가 장치 ID「{{.b}}」에 오프라인 라이브러리 규격 저장:「{{.c}}」",
	"b162": "저장 성공",
	"b163": "저장 실패",
	"b164": "사용자「{{.a}}」가 장치 ID「{{.b}}」오프라인 라이브러리를 규격「 {{.c}}」",
	"b165": "내보내기 규격 매개변수",
	"b166": "예용접 제어 모드",
	"b167": "용접1 제어 모드",
	"b168": "용접2 제어 모드",
	"b169": "용접3 제어 모드",
	"b170": "후용접 제어 모드",
	"b171": "가져오기 시 기존 데이터가 덮어쓰기됩니다. 정말로 가져오시겠습니까?",
	"b172": "이 파일은 해당 장비에 가져올 수 없습니다",
	"b173": "사용자「{{.a}}」가 장비 ID「{{.b}}」에 규격「{{.c}}」을 가져옵니다",
	"b174": "사용자「{{.a}}」가 장비 ID「{{.b}}」에 오프라인 라이브러리 규격「{{.c}}」을 가져옵니다",
	"b175": "가져오기 완료, 총 {{.a}}개 기록 가져옴",
	"b176": "상세보기",
	"b177": "삭제할 기록을 선택하세요",
	"b178": "기록 삭제 실패",
	"b179": "기록 삭제 성공",
	"b180": "선택한 기록을 삭제하시겠습니까?",
	"b181": "확인",
	"b182": "취소",
	"b183": "용접 기록 데이터 조회 오류, 잠시 후 다시 시도해 주세요",
	"b184": "현재 사용 중인 규격 번호",
	"b185": "현재 작업 단계",
	"b186": "현재 단계 실행 시간",
	"b187": "기록이 존재하지 않습니다",
	"b188": "검색 실패, 관련 용접 곡선을 찾을 수 없습니다",
	"b189": "경고 기록 데이터 가져오기 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"b190": "수정 기록 데이터 가져오기 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"b191": "규격 상세 정보",
	"b192": "‘다운로드’ 버튼을 클릭하여 ‘초기화’ 기능을 활성화하세요!",
	"b193": "압력 범위 초과",
	"b194": "판 두께 범위 초과",
	"b195": "행",
	"b196": "이미 존재함",
	"b197": "다른 작업이 진행 중이어서 일시적으로 처리할 수 없습니다",
	"b198": "용접점 관리 가져오기 작업 성공",
	"b199": "용접점 관리 가져오기 작업 실패",
	"b200": "용접점 관리 검증 작업 성공",
	"b201": "용접점 관리 검증 작업 실패",
	"b202": "납땜점 관리 삭제 작업 성공",
	"b203": "납땜점 관리 삭제 작업 실패",
	"b204": "압력 범위 초과(0-65535)",
	"b205": "판 두께 범위 초과(0-655.35)",
	"b206": "규격을 선택하세요! 규격이 없으면 새로 추가하세요",
	"b207": "용접점 관리 가져오기 작업 성공",
	"b208": "용접점 관리 가져오기 작업 실패",
	"b209": "로컬 용접점 데이터 삭제 실패",
	"b210": "용접점 생성 불가",
	"b211": "start 매개변수 누락!",
	"b212": "start 매개변수는 정수여야 합니다!",
	"b213": "end 매개변수 누락!",
	"b214": "end 매개변수는 정수여야 합니다!",
	"b215": "펄스 폭 기준값",
	"b216": "펄스 폭 누적값",
	"b217": "펄스 폭 카운트값",
	"b218": "납땜점 관리 다운로드 작업 실패",
	"r001": "장비 상태",
	"r002": "작동",
	"r003": "정비",
	"r004": "용접",
	"r005": "점검",
	"r006": "시험 압력",
	"r007": "시험 용접",
	"r008": "경보",
	"r009": "경보 기록 조회",
	"r010": "IO 상태",
	"r011": "용접 파형",
	"r012": "컨트롤러 정보",
	"r013": "실시간 데이터",
	"r014": "단일 용접점 수",
	"r015": "교대별 생산량",
	"r016": "총 생산 수",
	"r017": "총 용접점 수",
	"r018": "증분 수",
	"r019": "연마 횟수",
	"r020": "버스 바 전압",
	"r021": "현재 규격 스플래시 카운트 값",
	"r022": "총 스플래시 카운트 값",
	"r023": "컨트롤러 하드웨어 버전",
	"r024": "컨트롤러 소프트웨어 버전",
	"r025": "CPLD 소프트웨어 버전",
	"r026": "BOOT 버전",
	"r027": "전극",
	"r028": "입력",
	"r029": "출력",
	"r030": "시작 신호 1",
	"r031": "시작 신호 2",
	"r032": "프로그램 선택 1",
	"r033": "프로그램 선택 2",
	"r034": "프로그램 선택 4",
	"r035": "프로그램 선택 8",
	"r036": "프로그램 선택 16",
	"r037": "프로그램 선택 32",
	"r038": "검사 / 용접",
	"r039": "경보 리셋",
	"r040": "작동 / 연마",
	"r041": "비상 정지",
	"r042": "변압기 온도 스위치",
	"r043": "인버터 온도 스위치",
	"r044": "수류 스위치",
	"r045": "공기압 스위치",
	"r046": "용접 허용",
	"r047": "보류",
	"r048": "카운터 리셋",
	"r049": "프로그램 64",
	"r050": "프로그램 128",
	"r051": "프로그램 256",
	"r052": "프로그램 512",
	"r053": "전극 연마 확인",
	"r054": "전극 교체 확인",
	"r055": "보류 28",
	"r056": "보류 29",
	"r057": "보류 30",
	"r058": "보류 31",
	"r059": "기계 준비 완료",
	"r060": "공기 밸브 1",
	"r061": "공기 밸브 2",
	"r062": "공기 밸브 3",
	"r063": "공기 밸브 4",
	"r064": "용접 완료",
	"r065": "IGBT 트리거",
	"r066": "용접 요청",
	"r067": "모터 출력",
	"r068": "경보 출력",
	"r069": "전극 연마",
	"r070": "전극 교체",
	"r071": "연마 밸브",
	"r072": "동작 완료",
	"r073": "보류 20",
	"r074": "보류 21",
	"r075": "보류 22",
	"r076": "보류 23",
	"r077": "보류 24",
	"r078": "보류 25",
	"r079": "보류 26",
	"r080": "보류 27",
	"r081": "전류",
	"r082": "전압",
	"r083": "저항",
	"r084": "압력",
	"r085": "채집 설정",
	"r086": "설정",
	"r087": "전류 곡선 채집",
	"r088": "저항 곡선 채집",
	"r089": "전압 곡선 채집",
	"r090": "압력 곡선 수집",
	"r091": "설정 성공",
	"r092": "수집 곡선 업데이트 실패",
	"r093": "수집 곡선 업데이트 성공",
	"r094": "알 수 없는 작업 유형",
	"r095": "장치 번호 무효",
	"r096": "장치가 오프라인 상태입니다. 작업이 허용되지 않습니다.",
	"r097": "작업 성공",
	"r098": "작업 실패",
	"r099": "{{.a}} 알 수 없는 작업",
	"r100": "표시 매개변수 데이터 없음",
	"r101": "용접 데이터",
	"r102": "통계 데이터",
	"r103": "카운트",
	"r104": "보기",
	"r105": "용접 기록 번호",
	"r106": "컨트롤러 소프트웨어 버전",
	"r107": "용접점 관리 새로고침 작업 성공",
	"r108": "용접점 관리 새로고침 작업 실패",
	"r109": "가져오기 시 기존 데이터와 병합됩니다. 정말로 가져오시겠습니까?",
	"r110": "용접점 정보 조회 오류",
	"r111": "시험 용접 또는 시험 압력 모드에서는 해당 작업이 허용되지 않습니다",
	"r112": "연마 상태 모드에서는 해당 작업이 허용되지 않습니다",
	"r113": "기능 개발 중",
	"r114": "그래픽은 선택 영역 확대를 지원하며, 마우스 더블 클릭 시 기본 크기로 복원됩니다",
	"r115": "시스템 파일 읽기 실패",
	"r116": "새 납땜점 확인",
	"r117": "새 납땜점 선택",
	"r118": "스플래시 포인트 표시",
	"s001": "시스템 기록",
	"s002": "번호",
	"s003": "작업자",
	"s004": "대상 번호",
	"s005": "요약",
	"s006": "작업 시간",
	"s007": "단계화 상태",
	"s008": "단계 선택",
	"s009": "컨트롤러 준비 완료, 정상 작동 시작",
	"s010": "컨트롤러 용접 활성화",
	"s011": "상위 컴퓨터 I/O 포트 상태",
	"s012": "오류 삭제 명령",
	"s013": "전류 PWM 출력 설정값",
	"s014": "전극 압력 출력 설정값",
	"s015": "버스 전압 표시값",
	"s016": "1차 전류 표시값",
	"s017": "2차 전류 표시값",
	"s018": "전극 압력 표시값",
	"s019": "용접 카운터 초기화 명령",
	"s020": "Profibus 입력 포트 상태 문자 00",
	"s021": "Profibus 입력 포트 상태 문자 01",
	"s022": "Profibus 출력 포트 상태 문자 00",
	"s023": "Profibus 출력 포트 상태 문자 01",
	"s024": "Devicenet 입력 포트 상태 문자 00",
	"s025": "Devicenet 입력 포트 상태 문자 01",
	"s026": "Devicenet 출력 포트 상태 문자열 00",
	"s027": "Devicenet 출력 포트 상태 문자열 00",
	"s028": "파일을 클릭하거나 드래그하여 여기에 업로드하세요",
	"s029": "가져오기 완료",
	"s030": "새로 고침",
	"s031": "검증",
	"s032": "지우기",
	"s033": "새 땜점 생성",
	"s034": "납땜점 편집",
	"s035": "예비",
	"s036": "역사 경보 기록 입력 주소 포인터",
	"s037": "경보 상태 문자(0~31)",
	"s038": "예열 압력",
	"s039": "냉각 압력 0",
	"s040": "서서히 상승 압력",
	"s041": "용접 1 압력",
	"s042": "냉각 압력 1",
	"s043": "냉각 압력 2",
	"s044": "용접 3 압력",
	"s045": "서서히 하강 압력",
	"s046": "냉각 압력 3",
	"s047": "후용접 압력",
	"s048": "유지 압력",
	"s049": "용접 클램프 1 생산 중인 차종 모델, 필드 00(저장값은 ASCII 코드 값)",
	"s050": "용접 클램프 1 생산 중인 차종 모델, 필드 01(저장값은 ASCII 코드 값)",
	"s051": "용접 클램프 1 생산 중인 차종 모델, 필드 02(저장값은 ASCII 코드 값)",
	"s052": "용접 클램프 1 생산 중인 차종 모델, 필드 03(저장값은 ASCII 코드 값)",
	"s053": "용접 클램프 2 생산 중인 차종 모델, 필드 00(저장값은 ASCII 코드 값)",
	"s054": "용접 클램프 2 생산 중인 차종 모델, 필드 01(저장값은 ASCII 코드 값)",
	"s055": "용접 클램프 2 생산 중인 차종 모델, 필드 02(저장값은 ASCII 코드 값)",
	"s056": "용접 클램프 2 생산 중인 차종 모델, 필드 03(저장값은 ASCII 코드 값)",
	"s057": "전극 압력 모드",
	"s058": "시작 2 기능 선택 여부",
	"s059": "용접점 확인 기능 선택",
	"s060": "보완 용접 횟수",
	"s061": "시험 압력",
	"s062": "컨트롤러 CPLD 소프트웨어 버전",
	"s063": "통신 인터페이스 선택",
	"s064": "통신 주소",
	"s065": "네트워크 기능",
	"s066": "IP0",
	"s067": "IP1",
	"s068": "Device 일련번호",
	"s069": "DeviceNet BaudRate",
	"s070": "정격 전압",
	"s071": "인버터 개수",
	"s072": "용접 허용 기능 선택",
	"s073": "변압기 권선비",
	"s074": "변압기 효율",
	"s075": "정전류 제어 모드",
	"s076": "1차 전류 임계값",
	"s077": "IGBT 보호 경보 리셋 제어",
	"s078": "HMI 비상 정지 기능 선택",
	"s079": "프로그램 그룹 우선 선택 기능 선택",
	"s080": "비례 밸브 기능 선택",
	"s081": "컨트롤러 HMI 분리 오프라인 작동 기능 선택",
	"s082": "대개방 작업 트리거 모드",
	"s083": "전극 연마 확인 기능",
	"s084": "걸이 용접 시, 용접 클램프 소개방 지연 시작",
	"s085": "용접 클램프 1 로고스키 코일 전류 샘플링값과 실제 전류값의 비례 계수",
	"s086": "용접 클램프 2 로고스키 코일 전류 샘플링 값과 실제 전류 값의 비율 계수",
	"s087": "용접 클램프 1 CT 코일 전류 샘플링 값과 실제 전류 값의 비율 계수",
	"s088": "용접 클램프 2 CT 코일 전류 샘플링 값과 실제 전류 값의 비율 계수",
	"s089": "시스템 용접 클램프 1 지원 실제 최대 전류",
	"s090": "시스템 용접 클램프 2 지원 실제 최대 전류",
	"s091": "시스템 용접 클램프 1 현재 역률 각도",
	"s092": "시스템 용접 클램프 2 현재 역률 각도",
	"s093": "시스템 현재 용접 접촉 발동 제어 각도",
	"s094": "매달린 용접 컨트롤러 전원 차단 후 전극 암 개방 상태",
	"s095": "용접 완료 신호 및 동작 완료 신호 출력 모드",
	"s096": "버스바 전압 표시 계수, 현재 이 매개변수는 설정할 필요가 없습니다",
	"s097": "용접 클램프 1 최소 1차 전류 PWM 출력 설정값",
	"s098": "용접 클램프 1 1단계 1차 전류 PWM 출력 설정값",
	"s099": "용접 클램프 1 2단계 1차 전류 PWM 출력 설정값",
	"s100": "용접 클램프 1 3단계 1차 전류 PWM 출력 설정값",
	"s101": "용접 클램프 1 4단계 1차 전류 PWM 출력 설정값",
	"s102": "용접 클램프 1 5단계 1차 전류 PWM 출력 설정값",
	"s103": "용접 클램프 1 6단계 1차 전류 PWM 출력 설정값",
	"s104": "용접 클램프 1 최대 1차 전류 PWM 출력 설정값",
	"s105": "용접 클램프 1 1차 최소 전류 샘플링값",
	"s106": "용접 클램프 1 1단계 1차 전류 샘플링 값",
	"s107": "용접 클램프 1 2단계 1차 전류 샘플링 값",
	"s108": "용접 클램프 1 3단계 1차 전류 샘플링 값",
	"s109": "용접 클램프 1 4단계 1차 전류 샘플링 값",
	"s110": "용접 클램프 1 1차 5단계 전류 샘플링 값",
	"s111": "용접 클램프 1 1차 6단계 전류 샘플링 값",
	"s112": "용접 클램프 1 1차 최대 전류 샘플링 값",
	"s113": "용접 클램프 1 1차 최소 전류 표시값",
	"s114": "용접 클램프 1 1차 1단계 전류 표시값",
	"s115": "용접 클램프 1 1차 2단계 전류 표시값",
	"s116": "용접 클램프 1 1차 3단계 전류 표시값",
	"s117": "용접 클램프 1 1차 4단계 전류 표시값",
	"s118": "용접 클램프 1 1차 5단계 전류 표시값",
	"s119": "용접 클램프 1 1차 6단계 전류 표시값",
	"s120": "용접 클램프 1 1차 최대 전류 표시값",
	"s121": "용접 클램프 1 최소 2차 전류 PWM 출력 설정값",
	"s122": "용접 클램프 1 1단계 2차측 전류 PWM 출력 설정값",
	"s123": "용접 클램프 1 2단계 2차측 전류 PWM 출력 설정값",
	"s124": "용접 클램프 1 3단계 2차측 전류 PWM 출력 설정값",
	"s125": "용접 클램프 1 4단계 2차측 전류 PWM 출력 설정값",
	"s126": "용접 클램프 1 5단계 2차측 전류 PWM 출력 설정값",
	"s127": "용접 클램프 1 6단계 2차측 전류 PWM 출력 설정값",
	"s128": "용접 클램프 1 최대 2차측 전류 PWM 출력 설정값",
	"s129": "용접 클램프 1 2차측 최소 전류 샘플링값",
	"s130": "용접 클램프 1 1단계 2차 전류 샘플링 값",
	"s131": "용접 클램프 1 2단계 2차 전류 샘플링 값",
	"s132": "용접 클램프 1 3단계 2차 전류 샘플링 값",
	"s133": "용접 클램프 1 4단계 2차 전류 샘플링 값",
	"s134": "용접 클램프 1차측 5단계 전류 샘플링 값",
	"s135": "용접 클램프 1차측 6단계 전류 샘플링 값",
	"s136": "용접 클램프 1차측 최대 전류 샘플링 값",
	"s137": "용접 클램프 1차측 최소 전류 표시값",
	"s138": "용접 클램프 1차측 1단계 전류 표시값",
	"s139": "용접 클램프 1차측 2단계 전류 표시값",
	"s140": "용접 클램프 1차측 3단계 전류 표시값",
	"s141": "용접 클램프 1차측 4단계 전류 표시값",
	"s142": "용접 클램프 1차측 5단계 전류 표시값",
	"s143": "용접 클램프 1차측 6단계 전류 표시값",
	"s144": "용접 클램프 1차측 최대 전류 표시값",
	"s145": "용접 클램프 2 최소 2차측 전류 PWM 출력 설정값",
	"s146": "용접 클램프 2 1단계 2차측 전류 PWM 출력 설정값",
	"s147": "용접 클램프 2 2단계 2차측 전류 PWM 출력 설정값",
	"s148": "용접 클램프 2 3단계 2차 전류 PWM 출력 설정값",
	"s149": "용접 클램프 2 4단계 2차 전류 PWM 출력 설정값",
	"s150": "용접 클램프 2 5단계 2차 전류 PWM 출력 설정값",
	"s151": "용접 클램프 2 6단계 2차측 전류 PWM 출력 설정값",
	"s152": "용접 클램프 2 최대 2차측 전류 PWM 출력 설정값",
	"s153": "용접 클램프 2 2차측 최소 전류 샘플링값",
	"s154": "용접 클램프 2 2차 1단계 전류 샘플링 값",
	"s155": "용접 클램프 2 2차 2단계 전류 샘플링 값",
	"s156": "용접 클램프 2 2차 3단계 전류 샘플링 값",
	"s157": "용접 클램프 2 2차 4단계 전류 샘플링 값",
	"s158": "용접 클램프 2차측 5단계 전류 샘플링 값",
	"s159": "용접 클램프 2차측 6단계 전류 샘플링 값",
	"s160": "용접 클램프 2차측 최대 전류 샘플링 값",
	"s161": "용접 클램프 2차측 최소 전류 표시값",
	"s162": "용접 클램프 2차측 1단계 전류 표시값",
	"s163": "용접 클램프 2차측 2단계 전류 표시값",
	"s164": "용접 클램프 2차측 3단계 전류 표시값",
	"s165": "용접 클램프 2차측 4단계 전류 표시값",
	"s166": "용접 클램프 2차측 5단계 전류 표시값",
	"s167": "용접 클램프 2차측 6단계 전류 표시값",
	"s168": "용접 클램프 2차측 최대 전류 표시값",
	"s169": "용접 클램프 1 전극 1단계 압력 출력 설정값",
	"s170": "용접 클램프 1 전극 2단계 압력 출력 설정값",
	"s171": "용접 클램프 1 전극 1단계 압력 표시값 측정값",
	"s172": "용접 클램프 1 전극 2단계 압력 표시값 측정값",
	"s173": "용접 클램프 2 전극 1단계 압력 출력 설정값",
	"s174": "용접 클램프 2 전극 2단계 압력 출력 설정값",
	"s175": "용접 클램프 2 전극 1단계 압력 표시값 측정값",
	"s176": "용접 클램프 2 전극 2단계 압력 표시값 측정값",
	"s177": "1차 전류 교정 파라미터",
	"s178": "2차 전류 교정 파라미터",
	"s179": "용접 규격 선택 모드",
	"s180": "용접 클램프 1 1차 정전류 미세 조정 파라미터",
	"s181": "용접 클램프 1 2차 정전류 미세 조정 파라미터",
	"s182": "용접 클램프 2 1차 정전류 미세 조정 파라미터",
	"s183": "용접 클램프 2 2차 정전류 미세 조정 파라미터",
	"s184": "B 용접 클램프 수리 모드 상향 압력",
	"s185": "B 용접 클램프 수리 연마 압력",
	"s186": "용접 클램프 1 공정 용접점 제어 기능",
	"s187": "용접 클램프 2 공정 용접점 제어 기능",
	"s188": "단일 부품 용접점 수 공정 용접점 수 충족 시 경보 기능 선택",
	"s189": "교대별 생산량 용접점 계수 경보 기능 선택",
	"s190": "경보 재설정 후 즉시 타이머 시작",
	"s191": "용접 클램프 1 현재 용접 사이클 종료 판정 시간",
	"s192": "용접 클램프 2 현재 용접 사이클 종료 판정 시간",
	"s193": "용접 클램프 1 단일 부품 용접점 수 하한 설정값",
	"s194": "용접 클램프 2 단일 부품 용접점 수 하한 설정값",
	"s195": "용접 클램프 1 단일 부품 용접점 수 상한 설정값",
	"s196": "용접 클램프 2 단일 부품 용접점 수 상한 설정값",
	"s197": "용접 클램프 1 교대당 생산량 설정값",
	"s198": "용접 클램프 2 교대당 생산량 설정값",
	"s199": "용접 클램프 1 단일 부품 용접점 계수값",
	"s200": "용접 클램프 2 단일 부품 용접점 계수값",
	"s201": "카운터 전원 차단 시 알람 정보 저장 값",
	"s202": "용접 클램프 수 구성 모드",
	"s203": "용접 클램프 1 단계별 증급 수 설정값",
	"s204": "용접 클램프 2 단계별 증급 수 설정값",
	"s205": "용접 클램프 1 연마 횟수 설정값",
	"s206": "용접 클램프 2 연마 횟수 설정값",
	"s207": "용접 클램프 1 연마 사전 경고 용접점 설정값",
	"s208": "용접 클램프 2 연마 사전 경고 용접점 설정값",
	"s209": "용접 클램프 1 단계별 용접점 증가 수 1",
	"s210": "용접 클램프 1 전력 보정 1",
	"s211": "용접 클램프 1 압력 보정 1",
	"s212": "용접 클램프 1 단계별 용접 점수 2",
	"s213": "용접 클램프 1 전력 보정 2",
	"s214": "용접 클램프 1 압력 보정 2",
	"s215": "용접 클램프 1 단계별 용접 점수 3",
	"s216": "용접 클램프 1 전력 보정 3",
	"s217": "용접 클램프 1 압력 보정 3",
	"s218": "용접 클램프 1 단계 증가 용접점 수 4",
	"s219": "용접 클램프 1 전력 보정 4",
	"s220": "용접 클램프 1 압력 보정 4",
	"s221": "용접 클램프 1 단계 증설 용접점 수 5",
	"s222": "용접 클램프 1 전력 보정 5",
	"s223": "용접 클램프 1 압력 보정 5",
	"s224": "용접 클램프 1 단계 증설 용접점 수 6",
	"s225": "용접 클램프 1 전력 보정 6",
	"s226": "용접 클램프 1 압력 보정 6",
	"s227": "용접 클램프 1 단계별 용접 점수 7",
	"s228": "용접 클램프 1 전력 보정 7",
	"s229": "용접 클램프 1 압력 보정 7",
	"s230": "용접 클램프 1 단계별 용접 점수 8",
	"s231": "용접 클램프 1 전력 보정 8",
	"s232": "용접 클램프 1 압력 보정 8",
	"s233": "용접 클램프 1 단계 증가 용접점 수 9",
	"s234": "용접 클램프 1 전력 보정 9",
	"s235": "용접 클램프 1 압력 보정 9",
	"s236": "용접 클램프 2 단계별 용접점 수 1",
	"s237": "용접 클램프 2 전력 보정 1",
	"s238": "용접 클램프 2 압력 보정 1",
	"s239": "용접 클램프 2 단계별 용접점 수 2",
	"s240": "용접 클램프 2 전력 보정 2",
	"s241": "용접 클램프 2 압력 보정 2",
	"s242": "용접 클램프 2 단계별 용접 점수 3",
	"s243": "용접 클램프 2 전력 보정 3",
	"s244": "용접 클램프 2 압력 보정 3",
	"s245": "용접 클램프 2 단계별 용접 점수 4",
	"s246": "용접 클램프 2 전력 보정 4",
	"s247": "용접 클램프 2 압력 보정 4",
	"s248": "용접 클램프 2 단계별 용접 점수 5",
	"s249": "용접 클램프 2 전력 보정 5",
	"s250": "용접 클램프 2 압력 보정 5",
	"s251": "용접 클램프 2단계 증설 용접점 수 6",
	"s252": "용접 클램프 2단계 전력 보정 6",
	"s253": "용접 클램프 2단계 압력 보정 6",
	"s254": "용접 클램프 2단계 증설 용접점 수 7",
	"s255": "용접 클램프 2단계 전력 보정 7",
	"s256": "용접 클램프 2 압력 보정 7",
	"s257": "용접 클램프 2 단계 증가 용접 점수 8",
	"s258": "용접 클램프 2 전력 보정 8",
	"s259": "용접 클램프 2 압력 보정 8",
	"s260": "용접 클램프 2 단계 증가 용접 점수 9",
	"s261": "용접 클램프 2 전력 보상 9",
	"s262": "용접 클램프 2 압력 보상 9",
	"s263": "용접 클램프 2 최소 1차 전류 PWM 출력 설정값",
	"s264": "용접 클램프 2 1단계 1차 전류 PWM 출력 설정값",
	"s265": "용접 클램프 2 2단계 1차 전류 PWM 출력 설정값",
	"s266": "용접 클램프 2 3단계 1차 전류 PWM 출력 설정값",
	"s267": "용접 클램프 2 4단계 1차 전류 PWM 출력 설정값",
	"s268": "용접 클램프 2 5단계 1차 전류 PWM 출력 설정값",
	"s269": "용접 클램프 2 6단계 1차 전류 PWM 출력 설정값",
	"s270": "용접 클램프 2 최대 1차 전류 PWM 출력 설정값",
	"s271": "용접 클램프 2 1차 최소 전류 샘플링값",
	"s272": "용접 클램프 2 1차 1단계 전류 샘플링값",
	"s273": "용접 클램프 2 1차 2단계 전류 샘플링값",
	"s274": "용접 클램프 2 1차 3단계 전류 샘플링 값",
	"s275": "용접 클램프 2 1차 4단계 전류 샘플링 값",
	"s276": "용접 클램프 2 1차 5단계 전류 샘플링 값",
	"s277": "용접 클램프 2 1차 6단계 전류 샘플링 값",
	"s278": "용접 클램프 2 1차 최대 전류 샘플링 값",
	"s279": "용접 클램프 2 1차 최소 전류 표시값",
	"s280": "용접 클램프 2 1차 1단계 전류 표시값",
	"s281": "용접 클램프 2 1차 2단계 전류 표시값",
	"s282": "용접 클램프 2 1차 3단계 전류 표시값",
	"s283": "용접 클램프 2 1차 4단계 전류 표시값",
	"s284": "용접 클램프 2 1차 5단계 전류 표시값",
	"s285": "용접 클램프 2 1차 6단계 전류 표시값",
	"s286": "용접 클램프 2 1차 최대 전류 표시값",
	"s287": "카운터 전원 차단 시 저장 알람 정보값 상위 16비트",
	"s288": "UIR 조정 기능 선택",
	"s289": "UIR 조정 시 용접 시간 연장 기능 선택",
	"s290": "UIR 조정 시작 시점",
	"s291": "UIR 조정 전류 상승 최대 백분율",
	"s292": "UIR 조정 시 전류 하강 최대 백분율",
	"s293": "UIR 조정 시 시간 상승 최대 백분율",
	"s294": "2차측 전압 샘플링값을 표시값으로 변환하는 계수",
	"s295": "UIR 모니터링 기능 선택",
	"s296": "SDCARD 용접 기록 기능 선택",
	"s297": "SDCARD 하나의 파일에 저장 가능한 용접 기록 개수",
	"s298": "SDCARD 하나의 폴더 내 용접 파일 개수",
	"s299": "매달림 용접 대개방 이중 전기 제어 기능",
	"s300": "2차 저항 모니터링 0:꺼짐  1:켜짐",
	"s301": "저항 임계값 매개변수 글로벌 선택 0:꺼짐  1:켜짐",
	"s302": "내부 오프셋 주소",
	"s303": "전류 교정 시 버스 전압 값",
	"s304": "2차 전압 위치 감지",
	"s305": "시간 범위",
	"s306": "30일 이내",
	"s307": "60일 이내",
	"s308": "90일 이내",
	"s309": "개 곡선",
	"s310": "시간 범위 이상",
	"s311": "활성 곡선 설정 성공",
	"s312": "선택한 곡선이 유효값이 아닙니다",
	"s313": "곡선 번호가 유효하지 않습니다",
	"s314": "해당 곡선을 찾을 수 없어 삭제 실패",
	"s315": "삭제 실패",
	"s316": "삭제 성공",
	"s317": "샘플이 너무 적어 기준 곡선을 생성할 수 없습니다",
	"s318": "현재 기준 곡선을 컨트롤러에 다운로드하시겠습니까?",
	"s319": "현재 기준 곡선을 규격 라이브러리에 저장하시겠습니까?",
	"s320": "참조 곡선이 생성되지 않아 다운로드할 수 없습니다",
	"s321": "규격 번호가 유효하지 않습니다(0~143)",
	"s322": "곡선 데이터 오류",
	"s323": "참조 곡선 데이터가 비어 있어 저장할 수 없습니다",
	"s324": "참조 곡선 처리 오류",
	"s325": "참조 곡선 저장 오류",
	"s326": "경보 목록",
	"s327": "실행 실패",
	"s328": "실행 성공",
	"s329": "검증 실패",
	"s330": "실행 중...",
	"s331": "전류 임계값 모드가 백분율 모드이므로 {{.a}}는 정수만 설정 가능합니다. 확인해 주세요. 수정 후 적용되지 않으면 장치를 재연결하세요",
	"s332": "현재 디버그 모드입니다. 먼저 디버그를 종료한 후 종료하십시오",
	"s333": "전류 알고리즘 조정 모드",
	"s334": "빠름",
	"s335": "종료점",
	"s336": "시스템 구성",
	"s337": "장치 매개변수 백업/복원 병렬 처리 수",
	"s338": "HRC-670 저장 파일 디렉토리",
	"s339": "HRC-670 연결 포트 번호",
	"s340": "시스템 구성 보기",
	"s341": "시스템 구성 관리",
	"s342": "매개변수 저장 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"s343": "시스템 구성 가져오기 중 오류 발생, 잠시 후 다시 시도해 주세요",
	"s344": "장치 저장 성공",
	"s345": "HRC-670 저장 파일 디렉터리가 비어 있을 수 없습니다",
	"s346": "HRC-670 저장 파일 디렉터리 경로가 존재하지 않습니다!",
	"s347": "장치 매개변수 백업/복원 병렬 처리 수는 반드시 양의 정수여야 합니다",
	"s348": "장치 매개변수 백업/복원 병렬 처리 수 범위는 (1-8) 사이여야 합니다",
	"s349": "호환성 있는 무납땜 매핑",
	"i001": "데이터 관리",
	"i002": "데이터 정리",
	"i003": "용접 기록",
	"i004": "곡선 기록",
	"i005": "경보 기록",
	"i006": "UIR 참조 곡선",
	"i007": "규격 라이브러리 데이터",
	"i008": "규격 캐시 데이터",
	"i009": "시스템 캐시 데이터",
	"i010": "수정 기록",
	"i011": "시스템 기록",
	"i012": "주의: 데이터를 삭제하면 영구적으로 복구할 수 없습니다. 데이터 삭제 전에 반드시 백업하시기 바랍니다!!",
	"i013": "사용자「{{.a}}」가 {{.b}}의 데이터를 삭제함",
	"i014": "데이터 삭제 성공",
	"i015": "데이터 삭제 실패",
	"i016": "시간별 정리",
	"i017": "1개월",
	"i018": "3개월",
	"i019": "6개월",
	"i020": "1년",
	"i021": "정리 시간：",
	"i022": "시간에 따른 정리 아님",
	"i023": "사용자「{{.a}}」가 {{.b}}의 데이터를 정리했습니다, 정리 범위：",
	"i024": "기기 매개변수 자동 백업",
	"i025": "기기 자동 백업 활성화 후, 자동 백업 시간을 선택하세요",
	"i026": "롤링 데이터 기록 보존",
	"i027": "자동 정리를 활성화하려면, 자동 정리할 기록을 선택하세요",
	"i028": "자동 정리를 활성화하려면, 자동 정리할 시간 범위를 선택하세요",
	"i029": "이 페이지의 정리 기능은 수동으로 한 번만 수행됩니다. 자동 정리를 원하시면 '시스템 -> 시스템 설정'으로 이동하여 “데이터 기록 유지”를 활성화한 후, 변경 사항을 저장해야 적용됩니다.",
	"h001": "사용자「{{.a}}」가 규격 라이브러리「{{.b}}」(규격명: 「{{.c}}」)를 업데이트했습니다.",
	"h002": "시스템 기록 데이터 조회 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
	"h003": "사용자「{{.a}}」가 규격 라이브러리「{{.b}}」(규격명: 「{{.c}}」)를 새로 생성했습니다.",
	"h004": "사용자「{{.a}}」가 규격 라이브러리「{{.b}}」(규격명: 「{{.c}}」)를 삭제했습니다.",
	"h005": "사용자「{{.a}}」가 영역「{{.b}}」을 새로 생성했습니다",
	"h006": "사용자「{{.a}}」가 영역「{{.b}}」을 업데이트했습니다",
	"h007": "사용자「{{.a}}」가 영역「{{.b}}」을 삭제했습니다",
	"h008": "사용자「{{.a}}」가 영역「{{.b}}」을 복원했습니다",
	"h009": "사용자「{{.a}}」가 장비「{{.b}}」을 새로 생성했습니다",
	"h010": "사용자「{{.a}}」가 장비「{{.b}}」을 업데이트했습니다",
	"h011": "사용자「{{.a}}」가 기기「{{.b}}」를 삭제했습니다",
	"h012": "사용자「{{.a}}」가 기기「{{.b}}」를 복원했습니다",
	"h013": "사용자「{{.a}}」가 사용자「{{.b}}」를 새로 생성했습니다",
	"h014": "사용자「{{.a}}」가 사용자「{{.b}}」를 업데이트했습니다",
	"h015": "사용자「{{.a}}」가 사용자「{{.b}}」를 삭제했습니다",
	"h016": "사용자「{{.a}}」가 사용자「{{.b}}」를 복원했습니다",
	"h017": "로그인 비밀번호 오류 횟수가 「{{.a}}」회를 초과하여 계정 「{{.b}}」가 20분 동안 정지되었습니다",
	"h018": "사용자 「{{.a}}」가 로그인에 성공했습니다",
	"h019": "사용자 「{{.a}}」가 기기 「{{.b}}」의 곡선 수집 설정을 업데이트했습니다",
	"h020": "사용자「{{.a}}」가 캐릭터「{{.b}}」를 생성했습니다",
	"h021": "사용자「{{.a}}」가 캐릭터「{{.b}}」를 업데이트했습니다",
	"h022": "사용자「{{.a}}」가 역할「{{.b}}」을 삭제했습니다",
	"h023": "사용자「{{.a}}」가 역할「{{.b}}」을 복원했습니다",
	"h024": "사용자「{{.a}}」가 역할「{{.b}}」의 권한을 변경했습니다",
	"k001": "실시간 모니터링",
	"k002": "규격 파라미터",
	"k003": "생산 관리",
	"k004": "시스템 파라미터",
	"k005": "용접 기록",
	"k006": "경보 기록",
	"k007": "수정 기록",
	"k008": "용접점 관리",
	"k009": "장비 단말",
	"k010": "오프라인 라이브러리",
	"k011": "용접 클램프 선택",
	"k012": "스플래터 카운트 값",
	"k013": "스플래터 인식 임계값",
	"k014": "스플래터 시간 영역 임계값",
	"k015": "저항 기준값",
	"k016": "용접 저항 최소 임계값",
	"k017": "용접 저항 최대 임계값",
	"k018": "규격 번호 무효",
	"k019": "규격「{{.a}}」장치에서 로드 성공",
	"k020": "규격「{{.a}}」장치에서 로드 실패",
	"k021": "규격「{{.a}}」오프라인 데이터베이스에서 로드 성공",
	"k022": "규격「{{.a}}」오프라인 데이터베이스에서 로드 실패",
	"k023": "다운로드",
	"k024": "장비->라이브러리",
	"k025": "내보내기",
	"k026": "가져오기",
	"k027": "전극1 교정",
	"k028": "전극 2 교정",
	"k029": "전극 3 교정",
	"k030": "전극 4 교정",
	"k031": "전극 5 교정",
	"k032": "UIR 설정",
	"k033": "UIR 곡선",
	"k034": "UIP 사각형 그래프",
	"k035": "소프트웨어 업그레이드",
	"k036": "시스템 파라미터 백업",
	"k037": "용접기 구성",
	"k038": "용접기 유형",
	"k039": "일반 점용접",
	"k040": "로봇 점용접",
	"k041": "일반 이음용접",
	"k042": "전용 이음용접",
	"k043": "서스펜션 용접",
	"k044": "맞춤형 용접",
	"k045": "볼트 용접",
	"k046": "BYD 행거 용접",
	"k047": "용접점 확인",
	"k048": "닫기",
	"k049": "열기",
	"k050": "변압기 유형",
	"k051": "전극 연마 확인",
	"k052": "용접 완료 신호",
	"k053": "펄스 방식",
	"k054": "전압 레벨 방식",
	"k055": "전류 임계값 모드 선택",
	"k056": "절대값 모드",
	"k057": "백분율 모드",
	"k058": "UIP 경보 모드",
	"k059": "알림",
	"k060": "정지",
	"k061": "최소 버스 전압",
	"k062": "연속 용접 모드",
	"k063": "기준 버스 전압",
	"k064": "정전류 제어",
	"k065": "2차 정전류",
	"k066": "1차 정전류",
	"k067": "최대 전극 압력",
	"k068": "인버터 출력 주파수",
	"k069": "기능 설정",
	"k070": "HMI 비상 정지",
	"k071": "비례 밸브 기능",
	"k072": "규격 우선",
	"k073": "호스트 HMI 분리",
	"k074": "초기 설정",
	"k075": "눈금화 선택",
	"k076": "교정 전극 압력",
	"k077": "교정 1차 전류",
	"k078": "교정 2차 전류",
	"k079": "교정값",
	"k080": "설정값 %",
	"k081": "실측값 KN",
	"k082": "기능 선택",
	"k083": "UIR 모니터링",
	"k084": "시간 보정",
	"k085": "시작 시간",
	"k086": "기능 파라미터",
	"k087": "전류 조절 상한",
	"k088": "전류 조절 하한",
	"k089": "비산 시간 영역 한계",
	"k090": "비산 인식 한계",
	"k091": "시간 연장 상한",
	"k092": "2차 전압 계수",
	"k093": "저항 한계 매개변수 전체 선택",
	"k094": "2차 저항 모니터링",
	"k095": "용접 저항 최소 임계값",
	"k096": "용접 저항 최대 임계값",
	"k097": "시간 연장 상한",
	"k098": "기록 중지 UIR",
	"k099": "용접점 수",
	"k100": "선택된 곡선",
	"k101": "용접 시간",
	"k102": "용접점 번호",
	"k103": "곡선 삭제",
	"k104": "참조 곡선 생성",
	"k105": "->컨트롤러",
	"k106": "UIP 기능 선택",
	"k107": "UIP 기준값",
	"k108": "UIP 상한 허용 오차",
	"k109": "UIP 하한 허용 오차",
	"k110": "컨트롤러 업그레이드",
	"k111": "참고: 컨트롤러는 대기 상태일 때만 업그레이드할 수 있습니다. 업그레이드 중 전원을 차단하지 마십시오. 업그레이드 완료 후 컨트롤러를 재시작해야 합니다.",
	"k112": "펌웨어",
	"k113": "업그레이드할 펌웨어 파일을 선택하십시오",
	"k114": "파일 선택",
	"k115": "업그레이드",
	"k116": "공장 초기화",
	"k117": "참고: 컨트롤러가 공장 초기화되며 기존 데이터가 삭제됩니다",
	"k118": "옵션",
	"k119": "시스템 파라미터",
	"k120": "복원",
	"k121": "교정 파라미터",
	"k122": "2차 회로 임피던스",
	"k123": "용접 허용",
	"k124": "최대 2차 전류",
	"k125": "압력 출력 모드",
	"k126": "최대 용접 시간",
	"k127": "펄스 폭 최대 변화 범위",
	"k128": "정상 임피던스",
	"k129": "과대 임피던스",
	"k130": "소임피던스",
	"k131": "IO 제어 기능",
	"k132": "컨트롤러 우선",
	"k133": "RS-485 우선",
	"k134": "DeviceNet 우선",
	"k135": "MBTCP 우선",
	"k136": "ABCC 우선",
	"k137": "작동 모드 우선",
	"k138": "프로그래머 우선",
	"k139": "유효 우선",
	"k140": "규격 그룹 우선",
	"k141": "UIP 설정",
	"k142": "장치에서 로드 성공",
	"k143": "오프라인 라이브러리에서 로드 성공",
	"k144": "장치에서 로드 실패",
	"k145": "오프라인 라이브러리에서 로드 실패",
	"k146": "2차 전압 감지",
	"k147": "2차 전압 감지",
	"k148": "UIR 조정",
	"k149": "인버터 주파수",
	"k150": "1차 전류 교정 선택",
	"k151": "시스템 기본값",
	"k152": "사용자 자체 보정",
	"k153": "인버터 주파수",
	"k154": "1차 미세 조정 계수",
	"k155": "2차 전류 보정 선택",
	"k156": "PWM 설정",
	"k157": "실측값(KA)",
	"k158": "샘플링 값",
	"k159": "1차 미세 조정 계수",
	"k160": "2차 미세 조정 계수",
	"k161": "2차 미세 조정 계수",
	"k162": "1차 보정값",
	"k163": "2차 보정값",
	"k164": "전극 압력",
	"k165": "전극 1차",
	"k166": "전극 2차",
	"k167": "전극 1 카운터",
	"k168": "전극 2 카운터",
	"k169": "전극 1 연마",
	"k170": "전극 2 연마",
	"k171": "공작물 정보",
	"k172": "생산 배치 번호",
	"k173": "작업자",
	"k174": "시작1 규격",
	"k175": "시작2 규격",
	"k176": "조회",
	"k177": "규격 링크 단계",
	"k178": "시작 지연 예압",
	"k179": "기능 선택",
	"k180": "단계 증가 기능",
	"k181": "출력 보정(%)",
	"k182": "보강 용접 기능",
	"k183": "검사 기능",
	"k184": "최대 보완 용접 횟수",
	"k185": "시작 2 기능",
	"k186": "단일 용접점 카운터 경보",
	"k187": "교대별 생산량 카운터 경보",
	"k188": "경보 재설정 후 즉시 타이머 시작",
	"k189": "용접 클램프 공정 용접점 제어",
	"k190": "용접 클램프 공정 용접점 하한",
	"k191": "용접 클램프 공정 용접점 상한",
	"k192": "용접 클램프 용접점 종료 판정 시간(초)",
	"k193": "단일 부품 용접점 수",
	"k194": "교대별 생산량",
	"k195": "총 생산 수",
	"k196": "총 용접점 수",
	"k197": "현재값",
	"k198": "초기화",
	"k199": "단계 증가 수",
	"k200": "연마 횟수",
	"k201": "연마 사전 경보",
	"k202": "연마 상향 압력",
	"k203": "연마 하향 압력",
	"k204": "단계 증가 1",
	"k205": "단계 증가 2",
	"k206": "단계 증가 3",
	"k207": "단계 증가 4",
	"k208": "단계 증가 5",
	"k209": "단계 증가 6",
	"k210": "단계 증가 7",
	"k211": "단계 증가 8",
	"k212": "단계 증가 9",
	"k213": "공작물 명칭",
	"k214": "UIP 곡선 데이터 로드 오류",
	"k215": "오프라인 설정 획득 오류",
	"k216": "장비 설정 획득 오류",
	"k217": "용접 클램프 라인 생산량 설정값",
	"k218": "설정값",
	"k219": "압력 보정(%)",
	"k220": "날짜 범위 선택",
	"k221": "날짜",
	"k222": "시간",
	"k223": "경보 내용",
	"k224": "기록",
	"k225": "생성 시간",
	"k226": "차대 VIN 번호",
	"k227": "용접1(KA/ms)",
	"k228": "용접2(KA/ms)",
	"k229": "용접3(KA/ms)",
	"k230": "현재 사용 중인 용접 클램프 번호",
	"k231": "에너지(KJ)",
	"k232": "출력 펄스 폭(%)",
	"k233": "2차 전압(v)",
	"k234": "2차 저항(μOhm)",
	"k235": "UIP 값",
	"k236": "전체",
	"k237": "경보 없음",
	"k238": "경보 있음",
	"k239": "수정 전",
	"k240": "수정 후",
	"k241": "용접점 번호",
	"k242": "행 번호",
	"k243": "압력(N)",
	"k244": "판 두께(mm)",
	"k245": "차종",
	"k246": "용접점 정보",
	"k247": "판재1 재질",
	"k248": "판재1 두께(mm)",
	"k249": "판재2 재질",
	"k250": "판재 2 두께(mm)",
	"k251": "판재 3 재질",
	"k252": "판재 3 두께(mm)",
	"k253": "판재 4 재질",
	"k254": "판재 4 두께(mm)",
	"k255": "발생",
	"k256": "리셋",
	"k257": "내용",
	"k258": "차종 번호",
	"k259": "용접점 매핑 번호",
	"k260": "조회 매개변수 오류",
	"k261": "현재 장비",
	"k262": "전극1",
	"k263": "전극2",
	"k264": "라이브러리->장비",
	"k265": "오프라인 라이브러리 미설정, 동기화 불가",
	"k266": "내보내기 기능 오류",
	"k267": "규격 데이터 읽기 오류",
	"k268": "주키",
	"k269": "부품명",
	"k270": "예압 시간 ms",
	"k271": "추압 시간 ms",
	"k272": "예접류 KA",
	"k273": "예용접 시간 ms",
	"k274": "냉각 시간 0 ms",
	"k275": "서서히 상승 시간 ms",
	"k276": "용접1 전류 KA",
	"k277": "용접1 시간 ms",
	"k278": "냉각 시간 1 ms",
	"k279": "용접2 전류 KA",
	"k280": "용접2 시간 ms",
	"k281": "냉각 시간 2 ms",
	"k282": "용접 3 전류 KA",
	"k283": "용접 3 시간 ms",
	"k284": "서서히 하강 시간 ms",
	"k285": "냉각 시간 3 ms",
	"k286": "후용접 전류 KA",
	"k287": "후속 용접 시간 ms",
	"k288": "유지 시간 ms",
	"k289": "정지 시간 ms",
	"k290": "단계 증가 계수",
	"k291": "반복 횟수",
	"k292": "현재 용접점 카운트",
	"k293": "1차 커패시터 전압",
	"k294": "입력 포트 상태(In00~In31)",
	"k295": "출력 포트 상태 0(Out00~Out31)",
	"k296": "시스템 현재 작업 모드",
	"k297": "용접 클램프 1 단일 부품 용접점 카운트 값",
	"k298": "용접 클램프 2 단일 부품 용접점 카운트 값",
	"k299": "용접 클램프 1 교대 생산량 카운트 값",
	"k300": "용접 클램프 2 교대 생산량 카운트 값",
	"k301": "용접 클램프 1 총 생산량 카운트 값",
	"k302": "용접 클램프 2 총 생산량 카운트 값",
	"k303": "용접 클램프 1 총 용접점 카운트 값",
	"k304": "용접 클램프 2 총 용접점 계수값",
	"k305": "용접 클램프 1 단계별 증급 수 계수값",
	"k306": "용접 클램프 2 단계별 증급 수 계수값",
	"k307": "용접 클램프 1 연마 횟수 계수값",
	"k308": "용접 클램프 2 연마 횟수 계수값",
	"k309": "용접 클램프 2 현재 사용 규격 번호",
	"k310": "역사적 경보 기록 건수",
	"k311": "현재 사용 중인 용접 클램프 번호",
	"k312": "에너지",
	"k313": "부하 용량",
	"k314": "2차 전압",
	"k315": "2차 저항",
	"k316": "경보 표시",
	"k317": "시동1 규격 연결 단계 수",
	"k318": "시동 지연 과예압 기능 선택",
	"k319": "단계 증가 기능 선택",
	"k320": "A 용접 클램프 수리 모형 상향 압력",
	"k321": "보완 용접 기능 선택",
	"k322": "IO 기능 선택",
	"k323": "A 용접 클램프 수리 연마 압력",
	"k324": "용접 클램프 용접점 종료 판정 시간",
	"k325": "인버터 수",
	"k326": "전류 피드백 감지",
	"k327": "제어 기능 우선순위 설정",
	"k328": "단계 증가 단계 수 설정값",
	"k329": "단계 증가 단계 수 카운트값",
	"k330": "연마 횟수 설정값",
	"k331": "연마 횟수 카운트값",
	"k332": "연마 사전 경고 용접점 설정값",
	"k333": "단계 증가 용접점 수 1",
	"k334": "출력 보정 1",
	"k335": "압력 보정 1",
	"k336": "단계 증가 용접점 수 2",
	"k337": "출력 보정 2",
	"k338": "압력 보정 2",
	"k339": "단계 증가 땜납점 수 3",
	"k340": "출력 보정 3",
	"k341": "압력 보정 3",
	"k342": "단계 증가 땜납점 수 4",
	"k343": "출력 보정 4",
	"k344": "압력 보정 4",
	"k345": "단계 증가 용접점 수 5",
	"k346": "출력 보정 5",
	"k347": "압력 보정 5",
	"k348": "단계 증가 용접점 수 6",
	"k349": "출력 보정 6",
	"k350": "압력 보정 6",
	"k351": "단계별 용접점 수 7",
	"k352": "전력 보정 7",
	"k353": "압력 보정 7",
	"k354": "단계별 용접점 수 8",
	"k355": "전력 보정 8",
	"k356": "압력 보정 8",
	"k357": "단계별 용접점 수 9",
	"k358": "상향 압력 조정",
	"k359": "연마 하강 압력",
	"k360": "용접 클램프 구성",
	"k361": "용접 클램프 구성 모드",
	"k362": "단일 클램프",
	"k363": "이중 클램프",
	"k364": "다중 클램프",
	"k365": "클램프 최대 개방 모드",
	"k366": "유지식",
	"k367": "점동식",
	"k368": "정전 시 전극 암 상태",
	"k369": "소개방",
	"k370": "대개방",
	"k371": "용접 클램프 대개방 밸브 유형",
	"k372": "단일 전기 제어",
	"k373": "이중 전기 제어",
	"k374": "소 개방 지연 시작",
	"k375": "냉각수 부족 시 용접 허용",
	"k376": "용접 클램프 2 수류 모니터링 기능",
	"k377": "사용자「{{.a}}」가 수집 곡선 설정 업데이트, 장비 ID:「{{.b}}」",
	"k378": "사용자「{{.a}}」가 장비「{{.b}}」에 DIP 규격 라이브러리 다운로드:「{{.c}}」",
	"k379": "X",
	"k380": "Y",
	"k381": "Z",
	"k382": "땜납점 매핑 번호가 이미 존재합니다",
	"k383": "땜납점 추가 성공",
	"k384": "새 솔더 포인트 추가 실패",
	"k385": "솔더 포인트 편집 성공",
	"k386": "솔더 포인트 편집 실패",
	"k387": "솔더 포인트 확장 정보 저장 실패",
	"k388": "솔더 포인트 확장 정보 조회 실패",
	"k389": "다운로드 실패, 장치 {{.a}} 오프라인 상태일 수 있음",
	"k390": "땜납점 수가 유효하지 않거나 2000점을 초과함",
	"k391": "UIR이 아직 시작되지 않음",
	"k392": "UIR 기록이 이미 시작되었으므로 반복 시작할 필요 없음",
	"k393": "UIR 기록 시작",
	"k394": "UIR 기록 중지",
	"k395": "데이터 조회 오류",
	"k396": "선택된 곡선",
	"k397": "참조 곡선 생성",
	"k398": "->컨트롤러",
	"k399": "->PC",
	"k400": "한 번에 여러 곡선",
	"k401": "로드 성공",
	"k402": "경보 없음, 리셋 불필요",
	"k403": "시스템 매개변수 읽기 오류",
	"k404": "가져온 파일의 전류 임계값 모드가 가져온 장치와 일치하지 않음",
	"w001": "용접1 전류 초과",
	"w002": "용접1 전류 부족",
	"w003": "용접2 전류 초과",
	"w004": "용접2 전류 부족",
	"w005": "용접3 전류 초과",
	"w006": "용접3 전류 부족",
	"w007": "IGBT 고장",
	"w008": "비상정지 고장",
	"w009": "변압기1 온도 초과",
	"w010": "중주파 전원 온도 초과",
	"w011": "수류 스위치 오류",
	"w012": "공기압 스위치 오류",
	"w013": "용접 허용 시간 초과",
	"w014": "프로그래밍 입력1 시간 초과",
	"w015": "프로그래밍 입력2 시간 초과",
	"w016": "프로그래밍 입력 3 시간 초과",
	"w017": "메모리 파라미터 테이블 오류",
	"w018": "1차 커패시터 충전 시간 초과",
	"w019": "시스템 전원 켜짐 시 풋 스위치 닫힘 오류",
	"w020": "1차 커패시터 전압 과저하",
	"w021": "페라이트 데이터 쓰기 오류",
	"w022": "예압 시간 설정 오류",
	"w023": "RS485 통신 장애",
	"w024": "서스펜션 용접: 용접 클램프 2 수류 스위치 경보",
	"w025": "광학 격자 보호",
	"w026": "변압기 유형 설정 오류",
	"w027": "정전류 모드 설정 오류",
	"w028": "2차측 전류 단위 설정 오류",
	"w029": "용접 금지 인터페이스 경보",
	"w030": "전류 출력 보호",
	"w031": "변압기 2 온도 초과",
	"w032": "전류 피드백 오류",
	"w033": "용접 클램프 1 현재 용접점 수가 단일 부품 용접점 수 설정값에 도달함",
	"w034": "용접 클램프 1 실제 용접점 수가 단일 부품 용접점 상한을 초과함",
	"w035": "용접 클램프 1 실제 용접점 수가 단일 부품 용접점 하한값 미만",
	"w036": "용접 클램프 1 교대당 생산량 설정값 도달",
	"w037": "용접 클램프 1 연마 교체 사전 경고",
	"w038": "용접 클램프 1 연마 교체 경고",
	"w039": "용접 클램프 1 교체 경고",
	"w040": "용접 클램프 1 교체 사전 경고",
	"w041": "보류 01",
	"w042": "용접 클램프 2 현재 용접점 수가 단일 부품 용접점 수 설정값에 도달함",
	"w043": "용접 클램프 2 실제 용접점 수가 단일 부품 용접점 상한을 초과함",
	"w044": "용접 클램프 2 실제 용접점 수가 단일 부품 용접점 하한 미만임",
	"w045": "용접 클램프 2 교대 생산량 설정값 도달    ",
	"w046": "용접 클램프 2 연마 사전 경고",
	"w047": "용접 클램프 2 연마 경고",
	"w048": "용접 클램프 2 교체 경고",
	"w049": "용접 클램프 2 교체 사전 경고",
	"w050": "보류 49",
	"w051": "보류 50",
	"w052": "보류 51",
	"w053": "보류 52",
	"w054": "보류 53",
	"w055": "보류 54",
	"w056": "보류 55",
	"w057": "보류 56",
	"w058": "보류 57",
	"w059": "보류 58",
	"w060": "보류 59",
	"w061": "RTC 오류",
	"w062": "SD 카드 쓰기 오류",
	"w063": "교정 매개변수 오류",
	"w164": "증분 매개변수 오류",
	"w064": "전류 피드백선 접촉 불량",
	"w065": "용접 저항 과대 경보",
	"w066": "용접 저항 과소 경보",
	"w067": "2차 전압 케이블 이상",
	"w168": "UIP 너무 작음",
	"w069": "UIP 너무 큼",
	"w068": "자동 적응 용접 이상",
	"w097": "용접 스플래터 경고",
	"w098": "펄스 폭 출력 너무 큼",
	"w099": "UIP 너무 작음",
	"w100": "UIP 너무 큼",
	"z001": "{{.a}}(값 범위 「{{.b}}~{{.c}}{{.d}}」) 목표 설정값: 「{{.e}}」",
	"z002": "부동 소수점이 아닙니다:{{.a}}",
	"z003": "문자열이 아닙니다:{{.a}}",
	"z004": "길이가 {{.a}}가 아닙니다. 길이는 {{.b}}입니다.",
	"z005": "{{.a}} 이 메서드는 컨트롤러에서 구현되지 않았습니다.",
	"z006": "오프라인",
	"z007": "온라인",
	"z008": "예외",
	"z009": "삭제됨",
	"z010": "{{.a}} 입력 오류",
	"z011": "입력 검증 오류",
	"z012": "경보 기록",
	"z013": "디버깅 프로그램",
	"z014": "데이터베이스 관리",
	"z015": "수정 기록",
	"z016": "생산 관리",
	"z017": "규격 매개변수",
	"z018": "용접 기록",
	"z019": "실시간 모니터링",
	"z020": "시스템 매개변수",
	"z021": "활성화되지 않음",
	"z022": "정상",
	"z023": "동결됨",
	"z024": "삭제됨",
	"z025": "관리자",
	"z026": "운영자",
	"z027": "조회자",
	"z028": "규격 번호 범위 초과(0-959)",
	"z029": "규격 번호 범위 초과(0-63)",
	"z030": "컨트롤러 1이 유효한 정수가 아닙니다",
	"z031": "컨트롤러 2가 유효한 정수가 아닙니다",
	"z032": "규격 번호 1이 유효한 정수가 아닙니다",
	"z033": "규격 번호 2가 유효한 정수가 아닙니다",
	"z034": "동일 규격 비교 불가",
	"z035": "공작물명",
	"z036": "생산배치번호",
	"z037": "작업자",
	"z038": "오프라인 규격 조회 오류",
	"z039": "정수가 아닙니다:{{.a}}",
	"z040": "재연결 중...",
	"g001": "용접 클램프 3 총 용접점 계수값",
	"g002": "용접 클램프 4 총 용접점 계수값",
	"g003": "용접 클램프 5 총 용접점 계수값",
	"g004": "용접 클램프 3 단계별 증급 수 설정값",
	"g005": "용접 클램프 3 연마 횟수 설정값",
	"g006": "용접 클램프 3 연마 예비 경고 용접점 설정값",
	"g007": "용접 클램프 3 단계 증가 수 계수값",
	"g008": "용접 클램프 3 연마 횟수 계수값",
	"g009": "용접 클램프 4 단계 증가 수 설정값",
	"g010": "용접 클램프 4 연마 횟수 설정값",
	"g011": "용접 클램프 4 연마 사전 경고 용접점 설정값",
	"g012": "용접 클램프 4 단계 증급 수 카운트값",
	"g013": "용접 클램프 4 연마 횟수 카운트값",
	"g014": "용접 클램프 5 단계 증급 수 설정값",
	"g015": "용접 클램프 5 연마 횟수 설정값",
	"g016": "용접 클램프 5 연마 사전 경고 용접점 설정값",
	"g017": "용접 클램프 5 단계 증급 수 카운트값",
	"g018": "용접 클램프 5 연마 횟수 카운트값",
	"g019": "용접 클램프 3 단계 증접점 수 1",
	"g020": "용접 클램프 3 전력 보상 1",
	"g021": "용접 클램프 3 압력 보정 1",
	"g022": "용접 클램프 3 단계 증설 용접점 수 2",
	"g023": "용접 클램프 3 전력 보정 2",
	"g024": "용접 클램프 3 압력 보정 2",
	"g025": "용접 클램프 3 단계 증설 용접점 수 3",
	"g026": "용접 클램프 3 전력 보정 3",
	"g027": "용접 클램프 3 압력 보정 3",
	"g028": "용접 클램프 3 단계 증가 용접점 수 4",
	"g029": "용접 클램프 3 전력 보정 4",
	"g030": "용접 클램프 3 압력 보정 4",
	"g031": "용접 클램프 3단계 증설 용접점 수 5",
	"g032": "용접 클램프 3단계 전력 보정 5",
	"g033": "용접 클램프 3단계 압력 보정 5",
	"g034": "용접 클램프 3단계 증설 용접점 수 6",
	"g035": "용접 클램프 3단계 전력 보정 6",
	"g036": "용접 클램프 3 압력 보정 6",
	"g037": "용접 클램프 3 단계별 용접 점수 7",
	"g038": "용접 클램프 3 전력 보정 7",
	"g039": "용접 클램프 3 압력 보정 7",
	"g040": "용접 클램프 3 단계별 용접 점수 8",
	"g041": "용접 클램프 3 전력 보정 8",
	"g042": "용접 클램프 3 압력 보정 8",
	"g043": "용접 클램프 3 단계 증가 용접점 수 9",
	"g044": "용접 클램프 3 전력 보정 9",
	"g045": "용접 클램프 3 압력 보정 9",
	"g046": "용접 클램프 4 단계 증설 용접점 수 1",
	"g047": "용접 클램프 4 전력 보정 1",
	"g048": "용접 클램프 4 압력 보정 1",
	"g049": "용접 클램프 4 단계 증설 용접점 수 2",
	"g050": "용접 클램프 4 전력 보정 2",
	"g051": "용접 클램프 4 압력 보정 2",
	"g052": "용접 클램프 4 단계별 용접 점수 3",
	"g053": "용접 클램프 4 전력 보정 3",
	"g054": "용접 클램프 4 압력 보정 3",
	"g055": "용접 클램프 4 단계별 용접 점수 4",
	"g056": "용접 클램프 4 전력 보정 4",
	"g057": "용접 클램프 4 압력 보정 4",
	"g058": "용접 클램프 4 단계 증가 용접점 수 5",
	"g059": "용접 클램프 4 전력 보정 5",
	"g060": "용접 클램프 4 압력 보정 5",
	"g061": "용접 클램프 4단계 용접 점수 6",
	"g062": "용접 클램프 4단계 전력 보정 6",
	"g063": "용접 클램프 4단계 압력 보정 6",
	"g064": "용접 클램프 4단계 용접 점수 7",
	"g065": "용접 클램프 4단계 전력 보정 7",
	"g066": "용접 클램프 4 압력 보정 7",
	"g067": "용접 클램프 4 단계별 용접 점수 8",
	"g068": "용접 클램프 4 전력 보정 8",
	"g069": "용접 클램프 4 압력 보정 8",
	"g070": "용접 클램프 4 단계별 용접 점수 9",
	"g071": "용접 클램프 4 전력 보정 9",
	"g072": "용접 클램프 4 압력 보정 9",
	"g073": "용접 클램프 5 단계 증가 용접점 수 1",
	"g074": "용접 클램프 5 전력 보정 1",
	"g075": "용접 클램프 5 압력 보정 1",
	"g076": "용접 클램프 5단계 용접점 증가 수 2",
	"g077": "용접 클램프 5단계 전력 보정 2",
	"g078": "용접 클램프 5단계 압력 보정 2",
	"g079": "용접 클램프 5단계 용접점 증가 수 3",
	"g080": "용접 클램프 5단계 전력 보정 3",
	"g081": "용접 클램프 5 압력 보정 3",
	"g082": "용접 클램프 5 단계별 용접 점수 4",
	"g083": "용접 클램프 5 전력 보정 4",
	"g084": "용접 클램프 5 압력 보정 4",
	"g085": "용접 클램프 5 단계별 용접 점수 5",
	"g086": "용접 클램프 5 전력 보정 5",
	"g087": "용접 클램프 5 압력 보정 5",
	"g088": "용접 클램프 5 단계별 용접 점수 6",
	"g089": "용접 클램프 5 전력 보정 6",
	"g090": "용접 클램프 5 압력 보정 6",
	"g091": "용접 클램프 5단계 용접 점수 7",
	"g092": "용접 클램프 5단계 전력 보정 7",
	"g093": "용접 클램프 5단계 압력 보정 7",
	"g094": "용접 클램프 5단계 용접 점수 8",
	"g095": "용접 클램프 5단계 전력 보정 8",
	"g096": "용접 클램프 5 압력 보정 8",
	"g097": "용접 클램프 5 단계별 용접 점수 9",
	"g098": "용접 클램프 5 전력 보정 9",
	"g099": "용접 클램프 5 압력 보정 9",
	"g100": "용접 클램프 3 차측 정전류 미세 조정 매개변수",
	"g101": "용접 클램프 4 1차 정전류 미세 조정 파라미터",
	"g102": "용접 클램프 4 2차 정전류 미세 조정 파라미터",
	"g103": "용접 클램프 5 1차 정전류 미세 조정 파라미터",
	"g104": "용접 클램프 5 2차 정전류 미세 조정 파라미터",
	"g105": "용접 클램프 3 최소 1차 전류 PWM 출력 설정값",
	"g106": "용접 클램프 3 1단계 1차 전류 PWM 출력 설정값",
	"g107": "용접 클램프 3 2단계 1차 전류 PWM 출력 설정값",
	"g108": "용접 클램프 3 3단계 1차 전류 PWM 출력 설정값",
	"g109": "용접 클램프 3 4단계 1차 전류 PWM 출력 설정값",
	"g110": "용접 클램프 3 5단계 1차 전류 PWM 출력 설정값",
	"g111": "용접 클램프 3 6단계 1차 전류 PWM 출력 설정값",
	"g112": "용접 클램프 3 최대 1차 전류 PWM 출력 설정값",
	"g113": "용접 클램프 3 1차 최소 전류 샘플링 값",
	"g114": "용접 클램프 3 1차 1단계 전류 샘플링 값",
	"g115": "용접 클램프 3 1차 2단계 전류 샘플링 값",
	"g116": "용접 클램프 3 1차 3단계 전류 샘플링 값",
	"g117": "용접 클램프 3 1차 4단계 전류 샘플링 값",
	"g118": "용접 클램프 3 1차 5단계 전류 샘플링 값",
	"g119": "용접 클램프 3 1차 6단계 전류 샘플링 값",
	"g120": "용접 클램프 3 1차 최대 전류 샘플링 값",
	"g121": "용접 클램프 3 1차 최소 전류 표시값",
	"g122": "용접 클램프 3 1차 1단계 전류 표시값",
	"g123": "용접 클램프 3 1차 2단계 전류 표시값",
	"g124": "용접 클램프 3 1차 3단계 전류 표시값",
	"g125": "용접 클램프 3 1차 4단계 전류 표시값",
	"g126": "용접 클램프 3 1차 5단계 전류 표시값",
	"g127": "용접 클램프 3 1차 6단계 전류 표시값",
	"g128": "용접 클램프 3 1차 최대 전류 표시값",
	"g129": "용접 클램프 3 최소 2차 전류 PWM 출력 설정값",
	"g130": "용접 클램프 3 1단계 2차측 전류 PWM 출력 설정값",
	"g131": "용접 클램프 3 2단계 2차측 전류 PWM 출력 설정값",
	"g132": "용접 클램프 3 3단계 2차측 전류 PWM 출력 설정값",
	"g133": "용접 클램프 3 4단계 2차측 전류 PWM 출력 설정값",
	"g134": "용접 클램프 3 5단계 2차 전류 PWM 출력 설정값",
	"g135": "용접 클램프 3 6단계 2차 전류 PWM 출력 설정값",
	"g136": "용접 클램프 3 최대 2차 전류 PWM 출력 설정값",
	"g137": "용접 클램프 3 2차 최소 전류 샘플링값",
	"g138": "용접 클램프 3 1차 1단계 전류 샘플링 값",
	"g139": "용접 클램프 3 1차 2단계 전류 샘플링 값",
	"g140": "용접 클램프 3 1차 3단계 전류 샘플링 값",
	"g141": "용접 클램프 3 1차 4단계 전류 샘플링 값",
	"g142": "용접 클램프 3차측 5단계 전류 샘플링 값",
	"g143": "용접 클램프 3차측 6단계 전류 샘플링 값",
	"g144": "용접 클램프 3차측 최대 전류 샘플링 값",
	"g145": "용접 클램프 3차측 최소 전류 표시값",
	"g146": "용접 클램프 3차측 1단계 전류 표시값",
	"g147": "용접 클램프 3차측 2단계 전류 표시값",
	"g148": "용접 클램프 3차측 3단계 전류 표시값",
	"g149": "용접 클램프 3차측 4단계 전류 표시값",
	"g150": "용접 클램프 3차측 5단계 전류 표시값",
	"g151": "용접 클램프 3차 6단계 전류 표시값",
	"g152": "용접 클램프 3차 최대 전류 표시값",
	"g153": "용접 클램프 4 최소 1차 전류 PWM 출력 설정값",
	"g154": "용접 클램프 4 1단계 1차 전류 PWM 출력 설정값",
	"g155": "용접 클램프 4 2단계 1차 전류 PWM 출력 설정값",
	"g156": "용접 클램프 4 3단계 1차 전류 PWM 출력 설정값",
	"g157": "용접 클램프 4 4단계 1차 전류 PWM 출력 설정값",
	"g158": "용접 클램프 4 5단계 1차 전류 PWM 출력 설정값",
	"g159": "용접 클램프 4 6단계 1차 전류 PWM 출력 설정값",
	"g160": "용접 클램프 4 최대 1차 전류 PWM 출력 설정값",
	"g161": "용접 클램프 4 1차 최소 전류 샘플링 값",
	"g162": "용접 클램프 4 1차 1단계 전류 샘플링 값",
	"g163": "용접 클램프 4 1차 2단계 전류 샘플링 값",
	"g164": "용접 클램프 4 1차 3단계 전류 샘플링 값",
	"g165": "용접 클램프 4 1차 4단계 전류 샘플링 값",
	"g166": "용접 클램프 4 1차 5단계 전류 샘플링 값",
	"g167": "용접 클램프 4 1차 6단계 전류 샘플링 값",
	"g168": "용접 클램프 4 1차 최대 전류 샘플링 값",
	"g169": "용접 클램프 4 1차 최소 전류 표시값",
	"g170": "용접 클램프 4 1차 1단계 전류 표시값",
	"g171": "용접 클램프 4 1차 2단계 전류 표시값",
	"g172": "용접 클램프 4 1차 3단계 전류 표시값",
	"g173": "용접 클램프 4 1차 4단계 전류 표시값",
	"g174": "용접 클램프 4 1차 5단계 전류 표시값",
	"g175": "용접 클램프 4 1차 6단계 전류 표시값",
	"g176": "용접 클램프 4 1차 최대 전류 표시값",
	"g177": "용접 클램프 4 최소 2차 전류 PWM 출력 설정값",
	"g178": "용접 클램프 4 1단계 2차측 전류 PWM 출력 설정값",
	"g179": "용접 클램프 4 2단계 2차측 전류 PWM 출력 설정값",
	"g180": "용접 클램프 4 3단계 2차측 전류 PWM 출력 설정값",
	"g181": "용접 클램프 4 4단계 2차측 전류 PWM 출력 설정값",
	"g182": "용접 클램프 4 5단계 2차 전류 PWM 출력 설정값",
	"g183": "용접 클램프 4 6단계 2차 전류 PWM 출력 설정값",
	"g184": "용접 클램프 4 최대 2차 전류 PWM 출력 설정값",
	"g185": "용접 클램프 4 2차 최소 전류 샘플링값",
	"g186": "용접 클램프 4 차측 1단계 전류 샘플링 값",
	"g187": "용접 클램프 4 차측 2단계 전류 샘플링 값",
	"g188": "용접 클램프 4 차측 3단계 전류 샘플링 값",
	"g189": "용접 클램프 4 차측 4단계 전류 샘플링 값",
	"g190": "용접 클램프 4차측 5단계 전류 샘플링 값",
	"g191": "용접 클램프 4차측 6단계 전류 샘플링 값",
	"g192": "용접 클램프 4차측 최대 전류 샘플링 값",
	"g193": "용접 클램프 4차측 최소 전류 표시값",
	"g194": "용접 클램프 4차측 1단계 전류 표시값",
	"g195": "용접 클램프 4차측 2단계 전류 표시값",
	"g196": "용접 클램프 4차측 3단계 전류 표시값",
	"g197": "용접 클램프 4차측 4단계 전류 표시값",
	"g198": "용접 클램프 4차측 5단계 전류 표시값",
	"g199": "용접 클램프 4차측 6단계 전류 표시값",
	"g200": "용접 클램프 4차측 최대 전류 표시값",
	"g201": "용접 클램프 5차측 최소 1차 전류 PWM 출력 설정값",
	"g202": "용접 클램프 5차측 1단계 1차 전류 PWM 출력 설정값",
	"g203": "용접 클램프 5 2단계 1차 전류 PWM 출력 설정값",
	"g204": "용접 클램프 5 3단계 1차 전류 PWM 출력 설정값",
	"g205": "용접 클램프 5 4단계 1차 전류 PWM 출력 설정값",
	"g206": "용접 클램프 5 5단계 1차 전류 PWM 출력 설정값",
	"g207": "용접 클램프 5 6단계 1차 전류 PWM 출력 설정값",
	"g208": "용접 클램프 5 최대 1차 전류 PWM 출력 설정값",
	"g209": "용접 클램프 5 1차 최소 전류 샘플링값",
	"g210": "용접 클램프 5 1차 1단계 전류 샘플링값",
	"g211": "용접 클램프 5 1차 2단 전류 샘플링 값",
	"g212": "용접 클램프 5 1차 3단 전류 샘플링 값",
	"g213": "용접 클램프 5 1차 4단 전류 샘플링 값",
	"g214": "용접 클램프 5 1차 5단 전류 샘플링 값",
	"g215": "용접 클램프 5 1차 6단계 전류 샘플링 값",
	"g216": "용접 클램프 5 1차 최대 전류 샘플링 값",
	"g217": "용접 클램프 5 1차 최소 전류 표시값",
	"g218": "용접 클램프 5 1차 1단계 전류 표시값",
	"g219": "용접 클램프 5 1차 2단계 전류 표시값",
	"g220": "용접 클램프 5 1차 3단계 전류 표시값",
	"g221": "용접 클램프 5 1차 4단계 전류 표시값",
	"g222": "용접 클램프 5 1차 5단계 전류 표시값",
	"g223": "용접 클램프 5 1차 6단계 전류 표시값",
	"g224": "용접 클램프 5 1차 최대 전류 표시값",
	"g225": "용접 클램프 5 최소 2차측 전류 PWM 출력 설정값",
	"g226": "용접 클램프 5 1단계 2차측 전류 PWM 출력 설정값",
	"g227": "용접 클램프 5 2단계 2차측 전류 PWM 출력 설정값",
	"g228": "용접 클램프 5 3단계 2차측 전류 PWM 출력 설정값",
	"g229": "용접 클램프 5 4단계 2차측 전류 PWM 출력 설정값",
	"g230": "용접 클램프 5 5단계 2차측 전류 PWM 출력 설정값",
	"g231": "용접 클램프 5 6단계 2차측 전류 PWM 출력 설정값",
	"g232": "용접 클램프 5 최대 2차측 전류 PWM 출력 설정값",
	"g233": "용접 클램프 5 차측 최소 전류 샘플링 값",
	"g234": "용접 클램프 5 차측 1단계 전류 샘플링 값",
	"g235": "용접 클램프 5 차측 2단계 전류 샘플링 값",
	"g236": "용접 클램프 5 차측 3단계 전류 샘플링 값",
	"g237": "용접 클램프 5 차측 4단계 전류 샘플링 값",
	"g238": "용접 클램프 5 차측 5단계 전류 샘플링 값",
	"g239": "용접 클램프 5 차측 6단계 전류 샘플링 값",
	"g240": "용접 클램프 5 차측 최대 전류 샘플링 값",
	"g241": "용접 클램프 5차측 최소 전류 표시값",
	"g242": "용접 클램프 5차측 1단계 전류 표시값",
	"g243": "용접 클램프 5차측 2단계 전류 표시값",
	"g244": "용접 클램프 5차측 3단계 전류 표시값",
	"g245": "용접 클램프 5차측 4단계 전류 표시값",
	"g246": "용접 클램프 5차측 5단계 전류 표시값",
	"g247": "용접 클램프 5차측 6단계 전류 표시값",
	"g248": "용접 클램프 5차측 최대 전류 표시값",
	"g249": "용접 클램프 3차측 정전류 미세 조정 매개변수",
	"g250": "정의되지 않은 유형: {{.a}}",
	"g251": "용접 클램프 3 전극 1단계 압력 출력 설정값",
	"g252": "용접 클램프 3 전극 2단계 압력 출력 설정값",
	"g253": "용접 클램프 3 전극 1단계 압력 표시값 측정값",
	"g254": "용접 클램프 3 전극 2단계 압력 표시값 측정값",
	"g255": "용접 클램프 4 전극 1단계 압력 출력 설정값",
	"g256": "용접 클램프 4 전극 2단계 압력 출력 설정값",
	"g257": "용접 클램프 4 전극 1단계 압력 표시값 측정값",
	"g258": "용접 클램프 4 전극 2단계 압력 표시값 측정값",
	"g259": "용접 클램프 5 전극 1단계 압력 출력 설정값",
	"g260": "용접 클램프 5 전극 2단계 압력 출력 설정값",
	"g261": "용접 클램프 5 전극 1단계 압력 표시값 측정값",
	"g262": "용접 클램프 5 전극 2단계 압력 표시값 측정값",
	"d001": "새로 고침 수량",
	"d002": "납땜점 매핑 번호는 비어 있을 수 없으며 정수여야 합니다",
	"d003": "규격 번호는 비어 있을 수 없으며 정수여야 합니다",
	"d004": "압력은 공백일 수 없으며 정수여야 합니다",
	"d005": "판 두께는 공백일 수 없으며 소수여야 합니다(값 범위 0~99999.99)",
	"d006": "X는 공백일 수 없으며 소수여야 합니다(값 범위 0~999999.9999999999)",
	"d007": "Y는 공백일 수 없으며, 소수(값 범위 0~999999.9999999999)만 가능합니다.",
	"d008": "Z는 공백일 수 없으며, 소수(값 범위 0~999999.9999999999)만 가능합니다.",
	"d009": "판재1 두께는 소수만 가능(값 범위 0~99999.99)",
	"d010": "판재2 두께는 소수만 가능(값 범위 0~99999.99)",
	"d011": "판재3 두께는 소수만 가능(값 범위 0~99999.99)",
	"d012": "판재 4 두께는 소수점만 입력 가능(값 범위 0~99999.99)",
	"d013": "데이터 삭제 후 복구 불가, 삭제하시겠습니까?",
	"d014": "시스템 파라미터 기록",
	"d015": "용접점 관리 기록",
	"d016": "작업 유형",
	"d017": "추가",
	"d018": "수정",
	"d019": "매개변수 비교",
	"d020": "작업자가 존재하지 않아 조회 불가",
	"d021": "설정값 누락 또는 비정상",
	"d022": "가져오기 수량",
	"d023": "계산 중",
	"d024": "검증 수량",
	"d025": "삭제 수량",
	"d026": "다운로드 수량",
	"d027": "데이터 정리 성공",
	"d028": "데이터 정리 실패",
	"d029": "납땜점 새로고침",
	"d030": "선택한 장치에 대해 납땜점 새로고침 작업을 수행하시겠습니까?",
	"d031": "납땜점 새로고침 중 오류 발생, 작업 불가",
	"d032": "납땜점 새로고침 취소됨",
	"d033": "장치가 오프라인 상태입니다. 해당 작업을 수행할 수 없습니다.",
	"d034": "납땜점 새로고침 성공",
	"d035": "납땜점 새로고침 진행 상황 개요",
	"d036": "납땜점 새로고침 상세 정보",
	"d037": "납땜점 새로고침 진행률",
	"d038": "납땜점 새로고침 진행 중",
	"d039": "납땜점 새로고침 실패",
	"d040": "납땜점 새로고침을 취소하면 후속 작업이 중단됩니다. 정말 취소하시겠습니까?",
	"d041": "납땜점 작업이 재시도되었습니다.",
	"e001": "비산 통계",
	"e002": "비산 통계 보기",
	"e003": "비산 통계 관리",
	"e004": "조회 차원",
	"e005": "납땜점",
	"e006": "조회 차원 오류",
	"e007": "비산 카운트 값",
	"e008": "용접점 카운트 값",
	"e009": "총 카운트 값",
	"e010": "비산율",
	"e011": "데이터 뷰",
	"e012": "차종 데이터 획득 오류",
	"e013": "용접점 필터링, 여러 개는 쉼표(, )로 구분",
	"e014": "규격 필터링, 여러 개는 쉼표(,)로 구분",
	"e015": "클릭하여 복사",
	"e016": "순번",
	"e017": "<p>1. 다양한 차원을 선택하여 스플래터율을 조회할 수 있습니다. 선택 후 \"조회\"를 클릭하세요.</p><p>2. 영역/장비/차종/용접점/규격을 선택한 후, 좌측 목록의 각 영역/장비/차종을 추가 조회할 수 있습니다.</p><p>3. 용접점/규격을 선택한 후, 검색창에 필터링할 용접점/규격을 입력하여 조회할 수 있습니다(여러 개는 쉼표(,)로 구분).</p> 규격 선택 후, 좌측 목록의 각 영역/장비/차종을 추가로 선택하여 조회 가능</p><p>3. 용접점/규격 선택 후, 검색창에 필터링할 용접점/규격을 입력 후 조회 (복수 시 쉼표(,)로 구분)</p>",
	"e018": "공장",
	"e019": "스플래터 기록",
	"e020": "조회 내용 지우기",
	"e021": "내보내기 완료",
	"e022": "규격 내보내기 시작",
	"e023": "규격 내보내기 중",
	"e024": "동기화 시작",
	"e025": "동기화 중",
	"e026": "규격 가져오기 시작",
	"e027": "규격 가져오기 중",
	"e028": "규격 쓰기 오류",
	"e029": "시작 규격 번호",
	"e030": "종료 규격 번호",
	"e031": "차대 VIN 코드를 일련 번호로 변환",
	"e032": "차대 VIN 코드 범위 입력",
	"e033": "차대 VIN 코드는 정수여야 함",
	"e034": "UIP 값은 정수여야 하며 0보다 커야 함",
	"e035": "<p>역방향 필터링을 통해 경보 내용을 필터링할 수 있습니다. 예를 들어 ”!용접1 전류 초과“를 입력하면 ”용접1 전류 초과“ 기록이 필터링됩니다.</p>"
}